/* tslint:disable */
/* eslint-disable */
/**
 * Bank Backoffice Gateway - Documents
 * Partner\'s Bank Backoffice Gateway for Documents
 *
 * The version of the OpenAPI document: 5.2
 * Contact: viktor.dite@partnersbanka.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// URLSearchParams not necessarily used
// @ts-ignore

// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction,
    type EndpointOptions, // THIS IS CUSTOM
  } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AccountTerminationBankImmediateCabRequestV5
 */
export interface AccountTerminationBankImmediateCabRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof AccountTerminationBankImmediateCabRequestV5
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {BBanV2V2x4}
     * @memberof AccountTerminationBankImmediateCabRequestV5
     */
    'bban': BBanV2V2x4;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof AccountTerminationBankImmediateCabRequestV5
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @interface AccountTerminationBankImmediateCabRequestV5AllOf
 */
export interface AccountTerminationBankImmediateCabRequestV5AllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof AccountTerminationBankImmediateCabRequestV5AllOf
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {BBanV2V2x4}
     * @memberof AccountTerminationBankImmediateCabRequestV5AllOf
     */
    'bban': BBanV2V2x4;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof AccountTerminationBankImmediateCabRequestV5AllOf
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @interface AccountTerminationBankImmediateOtherRequestV5
 */
export interface AccountTerminationBankImmediateOtherRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof AccountTerminationBankImmediateOtherRequestV5
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {BBanV2V2x4}
     * @memberof AccountTerminationBankImmediateOtherRequestV5
     */
    'bban': BBanV2V2x4;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof AccountTerminationBankImmediateOtherRequestV5
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @interface AccountTerminationBankWithNoticePeriodRequestV5
 */
export interface AccountTerminationBankWithNoticePeriodRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof AccountTerminationBankWithNoticePeriodRequestV5
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {BBanV2V2x4}
     * @memberof AccountTerminationBankWithNoticePeriodRequestV5
     */
    'bban': BBanV2V2x4;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof AccountTerminationBankWithNoticePeriodRequestV5
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @interface AccountTerminationLimitationOfAutonomyRequestV5
 */
export interface AccountTerminationLimitationOfAutonomyRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof AccountTerminationLimitationOfAutonomyRequestV5
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof AccountTerminationLimitationOfAutonomyRequestV5
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @interface AddendumToFrameworkAgreementRequestV5
 */
export interface AddendumToFrameworkAgreementRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof AddendumToFrameworkAgreementRequestV5
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AddendumToFrameworkAgreementRequestV5
     */
    'productCode': AddendumToFrameworkAgreementRequestV5ProductCodeEnum;
    /**
     * An International Bank Account Number (IBAN) is a standardized, internationally recognized format for identifying bank accounts across different countries.
     * @type {string}
     * @memberof AddendumToFrameworkAgreementRequestV5
     */
    'iban': string;
    /**
     * Unique identifier of a user (Partners identity)
     * @type {string}
     * @memberof AddendumToFrameworkAgreementRequestV5
     */
    'pidUuidChild'?: string;
    /**
     * Unique identifier of a user (Partners identity)
     * @type {string}
     * @memberof AddendumToFrameworkAgreementRequestV5
     */
    'pidUuidDisponent'?: string;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof AddendumToFrameworkAgreementRequestV5
     */
    'mediaType': MediaTypeV5;
}

export const AddendumToFrameworkAgreementRequestV5ProductCodeEnum = {
    CURRENT_ACCOUNT_BASIC: 'OP_CURRENT_ACCOUNT_BASIC',
    CURRENT_ACCOUNT_SECONDARY: 'OP_CURRENT_ACCOUNT_SECONDARY',
    SAVINGS_ACCOUNT_BASIC: 'OP_SAVINGS_ACCOUNT_BASIC',
    SAVINGS_ACCOUNT_GOAL: 'OP_SAVINGS_ACCOUNT_GOAL',
    SAVINGS_ACCOUNT_CASH_RESERVE: 'OP_SAVINGS_ACCOUNT_CASH_RESERVE',
    CURRENT_ACCOUNT_SHARED: 'OP_CURRENT_ACCOUNT_SHARED',
    SAVINGS_ACCOUNT_SHARED: 'OP_SAVINGS_ACCOUNT_SHARED',
    SAVINGS_GOAL_SHARED: 'OP_SAVINGS_GOAL_SHARED',
    CURRENT_ACCOUNT_CHILD: 'OP_CURRENT_ACCOUNT_CHILD',
    SAVINGS_ACCOUNT_CHILD: 'OP_SAVINGS_ACCOUNT_CHILD',
    SAVINGS_ACCOUNT_GOAL_CHILD: 'OP_SAVINGS_ACCOUNT_GOAL_CHILD',
    ACCOUNT_PROTECTED: 'OP_ACCOUNT_PROTECTED'
} as const;

export type AddendumToFrameworkAgreementRequestV5ProductCodeEnum = typeof AddendumToFrameworkAgreementRequestV5ProductCodeEnum[keyof typeof AddendumToFrameworkAgreementRequestV5ProductCodeEnum];

/**
 * 
 * @export
 * @interface AddendumToFrameworkAgreementRequestV5AllOf
 */
export interface AddendumToFrameworkAgreementRequestV5AllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof AddendumToFrameworkAgreementRequestV5AllOf
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AddendumToFrameworkAgreementRequestV5AllOf
     */
    'productCode': AddendumToFrameworkAgreementRequestV5AllOfProductCodeEnum;
    /**
     * An International Bank Account Number (IBAN) is a standardized, internationally recognized format for identifying bank accounts across different countries.
     * @type {string}
     * @memberof AddendumToFrameworkAgreementRequestV5AllOf
     */
    'iban': string;
    /**
     * Unique identifier of a user (Partners identity)
     * @type {string}
     * @memberof AddendumToFrameworkAgreementRequestV5AllOf
     */
    'pidUuidChild'?: string;
    /**
     * Unique identifier of a user (Partners identity)
     * @type {string}
     * @memberof AddendumToFrameworkAgreementRequestV5AllOf
     */
    'pidUuidDisponent'?: string;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof AddendumToFrameworkAgreementRequestV5AllOf
     */
    'mediaType': MediaTypeV5;
}

export const AddendumToFrameworkAgreementRequestV5AllOfProductCodeEnum = {
    CURRENT_ACCOUNT_BASIC: 'OP_CURRENT_ACCOUNT_BASIC',
    CURRENT_ACCOUNT_SECONDARY: 'OP_CURRENT_ACCOUNT_SECONDARY',
    SAVINGS_ACCOUNT_BASIC: 'OP_SAVINGS_ACCOUNT_BASIC',
    SAVINGS_ACCOUNT_GOAL: 'OP_SAVINGS_ACCOUNT_GOAL',
    SAVINGS_ACCOUNT_CASH_RESERVE: 'OP_SAVINGS_ACCOUNT_CASH_RESERVE',
    CURRENT_ACCOUNT_SHARED: 'OP_CURRENT_ACCOUNT_SHARED',
    SAVINGS_ACCOUNT_SHARED: 'OP_SAVINGS_ACCOUNT_SHARED',
    SAVINGS_GOAL_SHARED: 'OP_SAVINGS_GOAL_SHARED',
    CURRENT_ACCOUNT_CHILD: 'OP_CURRENT_ACCOUNT_CHILD',
    SAVINGS_ACCOUNT_CHILD: 'OP_SAVINGS_ACCOUNT_CHILD',
    SAVINGS_ACCOUNT_GOAL_CHILD: 'OP_SAVINGS_ACCOUNT_GOAL_CHILD',
    ACCOUNT_PROTECTED: 'OP_ACCOUNT_PROTECTED'
} as const;

export type AddendumToFrameworkAgreementRequestV5AllOfProductCodeEnum = typeof AddendumToFrameworkAgreementRequestV5AllOfProductCodeEnum[keyof typeof AddendumToFrameworkAgreementRequestV5AllOfProductCodeEnum];

/**
 * 
 * @export
 * @interface AvailableAccountConfirmationRequestV5
 */
export interface AvailableAccountConfirmationRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof AvailableAccountConfirmationRequestV5
     */
    'tags'?: Array<string>;
    /**
     * Unique identifier of the account
     * @type {string}
     * @memberof AvailableAccountConfirmationRequestV5
     */
    'accountUuid': string;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof AvailableAccountConfirmationRequestV5
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @interface AvailableAccountConfirmationRequestV5AllOf
 */
export interface AvailableAccountConfirmationRequestV5AllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof AvailableAccountConfirmationRequestV5AllOf
     */
    'tags'?: Array<string>;
    /**
     * Unique identifier of the account
     * @type {string}
     * @memberof AvailableAccountConfirmationRequestV5AllOf
     */
    'accountUuid': string;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof AvailableAccountConfirmationRequestV5AllOf
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @interface AvailableBalanceConfirmationRequestV5
 */
export interface AvailableBalanceConfirmationRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof AvailableBalanceConfirmationRequestV5
     */
    'tags'?: Array<string>;
    /**
     * Unique identifier of the account
     * @type {string}
     * @memberof AvailableBalanceConfirmationRequestV5
     */
    'accountUuid': string;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof AvailableBalanceConfirmationRequestV5
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @interface BBanV2V2x4
 */
export interface BBanV2V2x4 {
    /**
     * 
     * @type {number}
     * @memberof BBanV2V2x4
     */
    'accountPrefix'?: number;
    /**
     * 
     * @type {number}
     * @memberof BBanV2V2x4
     */
    'accountNumber': number;
    /**
     * 
     * @type {string}
     * @memberof BBanV2V2x4
     */
    'bankCode': string;
}
/**
 * Enum account product codes
 * @export
 * @enum {string}
 */

export const BankAccountProductCodeV5 = {
    CURRENT_ACCOUNT_BASIC: 'OP_CURRENT_ACCOUNT_BASIC',
    CURRENT_ACCOUNT_SECONDARY: 'OP_CURRENT_ACCOUNT_SECONDARY',
    SAVINGS_ACCOUNT_BASIC: 'OP_SAVINGS_ACCOUNT_BASIC',
    SAVINGS_ACCOUNT_GOAL: 'OP_SAVINGS_ACCOUNT_GOAL',
    SAVINGS_ACCOUNT_CASH_RESERVE: 'OP_SAVINGS_ACCOUNT_CASH_RESERVE',
    CURRENT_ACCOUNT_SHARED: 'OP_CURRENT_ACCOUNT_SHARED',
    SAVINGS_ACCOUNT_SHARED: 'OP_SAVINGS_ACCOUNT_SHARED',
    SAVINGS_GOAL_SHARED: 'OP_SAVINGS_GOAL_SHARED',
    CURRENT_ACCOUNT_CHILD: 'OP_CURRENT_ACCOUNT_CHILD',
    SAVINGS_ACCOUNT_CHILD: 'OP_SAVINGS_ACCOUNT_CHILD',
    SAVINGS_ACCOUNT_GOAL_CHILD: 'OP_SAVINGS_ACCOUNT_GOAL_CHILD',
    ACCOUNT_PROTECTED: 'OP_ACCOUNT_PROTECTED'
} as const;

export type BankAccountProductCodeV5 = typeof BankAccountProductCodeV5[keyof typeof BankAccountProductCodeV5];


/**
 * 
 * @export
 * @interface BankAccountV5
 */
export interface BankAccountV5 {
    /**
     * 
     * @type {string}
     * @memberof BankAccountV5
     */
    'accountUuid': string;
    /**
     * 
     * @type {BankAccountProductCodeV5}
     * @memberof BankAccountV5
     */
    'productCode'?: BankAccountProductCodeV5;
    /**
     * 
     * @type {string}
     * @memberof BankAccountV5
     */
    'iban'?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountV5
     */
    'name'?: string;
}


/**
 * 
 * @export
 * @interface BankDocumentInfoV5
 */
export interface BankDocumentInfoV5 {
    /**
     * 
     * @type {OriginalDocumentV5}
     * @memberof BankDocumentInfoV5
     */
    'originalDocument': OriginalDocumentV5;
    /**
     * 
     * @type {string}
     * @memberof BankDocumentInfoV5
     */
    'bankDocumentUuid': string;
    /**
     * Human readable code of document. Primary search term on front-end
     * @type {string}
     * @memberof BankDocumentInfoV5
     */
    'bankDocumentCode': string;
    /**
     * 
     * @type {BankDocumentTypeV5}
     * @memberof BankDocumentInfoV5
     */
    'bankDocumentType': BankDocumentTypeV5;
    /**
     * 
     * @type {BankDocumentOwnerV5}
     * @memberof BankDocumentInfoV5
     */
    'ownedByClient': BankDocumentOwnerV5;
    /**
     * 
     * @type {BankAccountV5}
     * @memberof BankDocumentInfoV5
     */
    'account'?: BankAccountV5;
    /**
     * 
     * @type {Array<string>}
     * @memberof BankDocumentInfoV5
     */
    'tags': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BankDocumentInfoV5
     */
    'collectedDataType': string;
    /**
     * 
     * @type {string}
     * @memberof BankDocumentInfoV5
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof BankDocumentInfoV5
     */
    'expireAt': string;
    /**
     * 
     * @type {string}
     * @memberof BankDocumentInfoV5
     */
    'fileName': string;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof BankDocumentInfoV5
     */
    'mediaType': MediaTypeV5;
    /**
     * 
     * @type {Array<SignatureV5>}
     * @memberof BankDocumentInfoV5
     */
    'signatures': Array<SignatureV5>;
}


/**
 * 
 * @export
 * @interface BankDocumentOwnerV5
 */
export interface BankDocumentOwnerV5 {
    /**
     * 
     * @type {string}
     * @memberof BankDocumentOwnerV5
     */
    'pidUuid': string;
    /**
     * 
     * @type {string}
     * @memberof BankDocumentOwnerV5
     */
    'fullName'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const BankDocumentTemplateV5 = {
    AVAILABLE_BALANCE_CONFIRMATION: 'AVAILABLE_BALANCE_CONFIRMATION',
    SIPO_CONFIRMATION: 'SIPO_CONFIRMATION',
    STANDING_ORDER_CONFIRMATION: 'STANDING_ORDER_CONFIRMATION',
    DIRECT_DEBIT_CONFIRMATION: 'DIRECT_DEBIT_CONFIRMATION',
    AVAILABLE_ACCOUNT_CONFIRMATION: 'AVAILABLE_ACCOUNT_CONFIRMATION',
    FOREIGN_POLICE_CONFIRMATION: 'FOREIGN_POLICE_CONFIRMATION',
    COMMITMENTS_CONFIRMATION: 'COMMITMENTS_CONFIRMATION',
    STATEMENT_OF_PAYMENTS: 'STATEMENT_OF_PAYMENTS',
    STATEMENT_OF_FEES: 'STATEMENT_OF_FEES',
    CARD_PAYMENT_CONFIRMATION: 'CARD_PAYMENT_CONFIRMATION',
    DOMESTIC_PAYMENT_CONFIRMATION: 'DOMESTIC_PAYMENT_CONFIRMATION',
    SEPA_PAYMENT_CONFIRMATION: 'SEPA_PAYMENT_CONFIRMATION',
    FOREIGN_PAYMENT_CONFIRMATION: 'FOREIGN_PAYMENT_CONFIRMATION',
    EXAMPLE_TEMPLATE: 'EXAMPLE_TEMPLATE',
    LOAN_INTEREST_RATE_GUARANTEE_UNSECURED: 'LOAN_INTEREST_RATE_GUARANTEE_UNSECURED',
    LOAN_INTEREST_RATE_GUARANTEE_SECURED: 'LOAN_INTEREST_RATE_GUARANTEE_SECURED',
    LOAN_IZU_UNSECURED: 'LOAN_IZU_UNSECURED',
    LOAN_SCHEDULE_UNSECURED: 'LOAN_SCHEDULE_UNSECURED',
    LOAN_SCHEDULE_SECURED: 'LOAN_SCHEDULE_SECURED',
    LOAN_EUROPEAN_STANDARDISED_INFORMATION_SHEET_SECURED: 'LOAN_EUROPEAN_STANDARDISED_INFORMATION_SHEET_SECURED',
    LOAN_ACCESSION_TO_DEBT_AGREEMENT_SECURED: 'LOAN_ACCESSION_TO_DEBT_AGREEMENT_SECURED',
    LOAN_ACCESSION_TO_DEBT_AGREEMENT_UNSECURED: 'LOAN_ACCESSION_TO_DEBT_AGREEMENT_UNSECURED',
    LOAN_APPLICATION_UNSECURED: 'LOAN_APPLICATION_UNSECURED',
    LOAN_APPLICATION_SECURED: 'LOAN_APPLICATION_SECURED',
    LOAN_CALCULATION_WHEN_WITHDRAWING_FROM_A_LOAN: 'LOAN_CALCULATION_WHEN_WITHDRAWING_FROM_A_LOAN',
    LOAN_CONFIRMATION_OF_CANCELLATION_OF_APPLICATION: 'LOAN_CONFIRMATION_OF_CANCELLATION_OF_APPLICATION',
    LOAN_CONFIRMATION_OF_CONSUMER_LOAN_REPAYMENT: 'LOAN_CONFIRMATION_OF_CONSUMER_LOAN_REPAYMENT',
    LOAN_CONFIRMATION_OF_CONSUMER_LOAN_REPAYMENT_AND_TERMINATION_OF_THE_ACCESSION_OBLIGATION: 'LOAN_CONFIRMATION_OF_CONSUMER_LOAN_REPAYMENT_AND_TERMINATION_OF_THE_ACCESSION_OBLIGATION',
    LOAN_CONTRACT_SECURED: 'LOAN_CONTRACT_SECURED',
    LOAN_CONTRACT_UNSECURED: 'LOAN_CONTRACT_UNSECURED',
    LOAN_EUROPEAN_STANDARDISED_INFORMATION_SHEET_UNSECURED: 'LOAN_EUROPEAN_STANDARDISED_INFORMATION_SHEET_UNSECURED',
    LOAN_EXTRAORDINARY_FULL_INSTALMENT_CALCULATION: 'LOAN_EXTRAORDINARY_FULL_INSTALMENT_CALCULATION',
    LOAN_NOTICE_OF_EARLY_REPAYMENT_OF_CONSUMER_LOAN_UNSECURED: 'LOAN_NOTICE_OF_EARLY_REPAYMENT_OF_CONSUMER_LOAN_UNSECURED',
    LOAN_PRE_CONTRACTUAL_EXPLANATION: 'LOAN_PRE_CONTRACTUAL_EXPLANATION',
    LOAN_STANDARD_EUROPEAN_CONSUMER_CREDIT_INFORMATION_UNSECURED: 'LOAN_STANDARD_EUROPEAN_CONSUMER_CREDIT_INFORMATION_UNSECURED',
    LOAN_CONFIRMATION_OF_PAID_INTEREST_SECURED: 'LOAN_CONFIRMATION_OF_PAID_INTEREST_SECURED',
    LOAN_AGREEMENT: 'LOAN_AGREEMENT',
    LOAN_ACCESSOR_AGREEMENT: 'LOAN_ACCESSOR_AGREEMENT',
    LOAN_REFINANCING_TERMINATION: 'LOAN_REFINANCING_TERMINATION',
    LOAN_EARLY_REPAYMENT_NOTICE: 'LOAN_EARLY_REPAYMENT_NOTICE',
    FRAMEWORK_AGREEMENT: 'FRAMEWORK_AGREEMENT',
    FRAMEWORK_AGREEMENT_AMENDMENT: 'FRAMEWORK_AGREEMENT_AMENDMENT',
    ADDENDUM_TO_FRAMEWORK_AGREEMENT: 'ADDENDUM_TO_FRAMEWORK_AGREEMENT',
    COMPLAINTS_PROCEDURE: 'COMPLAINTS_PROCEDURE',
    PRICE_LIST: 'PRICE_LIST',
    PRICE_LIST_AMENDMENT: 'PRICE_LIST_AMENDMENT',
    TERMS_AND_CONDITIONS: 'TERMS_AND_CONDITIONS',
    TERMS_AND_CONDITIONS_AMENDMENT: 'TERMS_AND_CONDITIONS_AMENDMENT',
    TERMS_AND_CONDITIONS_ADJUSTMENT: 'TERMS_AND_CONDITIONS_ADJUSTMENT',
    TERMS_AND_CONDITIONS_PAYMENTS: 'TERMS_AND_CONDITIONS_PAYMENTS',
    TERMS_AND_CONDITIONS_PAYMENTS_AMENDMENT: 'TERMS_AND_CONDITIONS_PAYMENTS_AMENDMENT',
    TERMS_AND_CONDITIONS_PAYMENTS_ADJUSTMENT: 'TERMS_AND_CONDITIONS_PAYMENTS_ADJUSTMENT',
    TERMS_AND_CONDITIONS_CARDS: 'TERMS_AND_CONDITIONS_CARDS',
    TERMS_AND_CONDITIONS_CARDS_AMENDMENT: 'TERMS_AND_CONDITIONS_CARDS_AMENDMENT',
    TERMS_AND_CONDITIONS_CARDS_ADJUSTMENT: 'TERMS_AND_CONDITIONS_CARDS_ADJUSTMENT',
    TERMS_AND_CONDITIONS_CARDS_GOOGLE_AND_APPLE_PAY: 'TERMS_AND_CONDITIONS_CARDS_GOOGLE_AND_APPLE_PAY',
    MOBILITY_REQUEST: 'MOBILITY_REQUEST',
    INTEREST_RATES: 'INTEREST_RATES',
    PERSONAL_DATA_PROCESSING_INFORMATION: 'PERSONAL_DATA_PROCESSING_INFORMATION',
    PERMANENTLY_ACCESSIBLE_INFORMATION: 'PERMANENTLY_ACCESSIBLE_INFORMATION',
    TERMS_OF_USE_MOBILE_APPLICATION: 'TERMS_OF_USE_MOBILE_APPLICATION',
    GROUP_MARKETING_CONSENT: 'GROUP_MARKETING_CONSENT',
    INFORMATION_ON_THE_DEPOSIT_INSURANCE_SYSTEM: 'INFORMATION_ON_THE_DEPOSIT_INSURANCE_SYSTEM',
    MOBILITY_CHANGE_ACCOUNT: 'MOBILITY_CHANGE_ACCOUNT',
    MOBILITY_PAYERS: 'MOBILITY_PAYERS',
    ACCOUNT_TERMINATION_BANK_IMMEDIATE_CAB: 'ACCOUNT_TERMINATION_BANK_IMMEDIATE_CAB',
    ACCOUNT_TERMINATION_BANK_IMMEDIATE_OTHER: 'ACCOUNT_TERMINATION_BANK_IMMEDIATE_OTHER',
    ACCOUNT_TERMINATION_BANK_WITH_NOTICE_PERIOD: 'ACCOUNT_TERMINATION_BANK_WITH_NOTICE_PERIOD',
    ACCOUNT_TERMINATION_LIMITATION_OF_AUTONOMY: 'ACCOUNT_TERMINATION_LIMITATION_OF_AUTONOMY',
    OTHER: 'OTHER'
} as const;

export type BankDocumentTemplateV5 = typeof BankDocumentTemplateV5[keyof typeof BankDocumentTemplateV5];


/**
 * 
 * @export
 * @enum {string}
 */

export const BankDocumentTypeV5 = {
    AVAILABLE_BALANCE_CONFIRMATION: 'AVAILABLE_BALANCE_CONFIRMATION',
    SIPO_CONFIRMATION: 'SIPO_CONFIRMATION',
    STANDING_ORDER_CONFIRMATION: 'STANDING_ORDER_CONFIRMATION',
    DIRECT_DEBIT_CONFIRMATION: 'DIRECT_DEBIT_CONFIRMATION',
    AVAILABLE_ACCOUNT_CONFIRMATION: 'AVAILABLE_ACCOUNT_CONFIRMATION',
    FOREIGN_POLICE_CONFIRMATION: 'FOREIGN_POLICE_CONFIRMATION',
    COMMITMENTS_CONFIRMATION: 'COMMITMENTS_CONFIRMATION',
    STATEMENT_OF_PAYMENTS: 'STATEMENT_OF_PAYMENTS',
    STATEMENT_OF_FEES: 'STATEMENT_OF_FEES',
    TRANSACTION_CONFIRMATION: 'TRANSACTION_CONFIRMATION',
    FRAMEWORK_AGREEMENT: 'FRAMEWORK_AGREEMENT',
    FRAMEWORK_AGREEMENT_AMENDMENT: 'FRAMEWORK_AGREEMENT_AMENDMENT',
    ADDENDUM_TO_FRAMEWORK_AGREEMENT: 'ADDENDUM_TO_FRAMEWORK_AGREEMENT',
    COMPLAINTS_PROCEDURE: 'COMPLAINTS_PROCEDURE',
    PRICE_LIST: 'PRICE_LIST',
    PRICE_LIST_AMENDMENT: 'PRICE_LIST_AMENDMENT',
    TERMS_AND_CONDITIONS: 'TERMS_AND_CONDITIONS',
    TERMS_AND_CONDITIONS_AMENDMENT: 'TERMS_AND_CONDITIONS_AMENDMENT',
    TERMS_AND_CONDITIONS_ADJUSTMENT: 'TERMS_AND_CONDITIONS_ADJUSTMENT',
    TERMS_AND_CONDITIONS_PAYMENTS: 'TERMS_AND_CONDITIONS_PAYMENTS',
    TERMS_AND_CONDITIONS_PAYMENTS_AMENDMENT: 'TERMS_AND_CONDITIONS_PAYMENTS_AMENDMENT',
    TERMS_AND_CONDITIONS_PAYMENTS_ADJUSTMENT: 'TERMS_AND_CONDITIONS_PAYMENTS_ADJUSTMENT',
    TERMS_AND_CONDITIONS_CARDS: 'TERMS_AND_CONDITIONS_CARDS',
    TERMS_AND_CONDITIONS_CARDS_AMENDMENT: 'TERMS_AND_CONDITIONS_CARDS_AMENDMENT',
    TERMS_AND_CONDITIONS_CARDS_ADJUSTMENT: 'TERMS_AND_CONDITIONS_CARDS_ADJUSTMENT',
    TERMS_AND_CONDITIONS_CARDS_GOOGLE_AND_APPLE_PAY: 'TERMS_AND_CONDITIONS_CARDS_GOOGLE_AND_APPLE_PAY',
    MOBILITY_REQUEST: 'MOBILITY_REQUEST',
    INTEREST_RATES: 'INTEREST_RATES',
    PERSONAL_DATA_PROCESSING_INFORMATION: 'PERSONAL_DATA_PROCESSING_INFORMATION',
    PERMANENTLY_ACCESSIBLE_INFORMATION: 'PERMANENTLY_ACCESSIBLE_INFORMATION',
    TERMS_OF_USE_MOBILE_APPLICATION: 'TERMS_OF_USE_MOBILE_APPLICATION',
    GROUP_MARKETING_CONSENT: 'GROUP_MARKETING_CONSENT',
    INFORMATION_ON_THE_DEPOSIT_INSURANCE_SYSTEM: 'INFORMATION_ON_THE_DEPOSIT_INSURANCE_SYSTEM',
    MOBILITY_CHANGE_ACCOUNT: 'MOBILITY_CHANGE_ACCOUNT',
    MOBILITY_PAYERS: 'MOBILITY_PAYERS',
    ACCOUNT_TERMINATION_BANK_IMMEDIATE_CAB: 'ACCOUNT_TERMINATION_BANK_IMMEDIATE_CAB',
    ACCOUNT_TERMINATION_BANK_IMMEDIATE_OTHER: 'ACCOUNT_TERMINATION_BANK_IMMEDIATE_OTHER',
    ACCOUNT_TERMINATION_BANK_WITH_NOTICE_PERIOD: 'ACCOUNT_TERMINATION_BANK_WITH_NOTICE_PERIOD',
    ACCOUNT_TERMINATION_LIMITATION_OF_AUTONOMY: 'ACCOUNT_TERMINATION_LIMITATION_OF_AUTONOMY',
    EXAMPLE: 'EXAMPLE',
    UNSUPPORTED: 'UNSUPPORTED'
} as const;

export type BankDocumentTypeV5 = typeof BankDocumentTypeV5[keyof typeof BankDocumentTypeV5];


/**
 * 
 * @export
 * @enum {string}
 */

export const ClientDocumentCategoryV5 = {
    INCOMING_MOBILITY: 'INCOMING_MOBILITY',
    OUTGOING_MOBILITY: 'OUTGOING_MOBILITY',
    ACCOUNT_CANCELLATION: 'ACCOUNT_CANCELLATION',
    CONFIRMATIONS_STATEMENTS: 'CONFIRMATIONS_STATEMENTS',
    COMPLAINTS: 'COMPLAINTS',
    INHERITANCE_POWER_OF_ATTORNEY: 'INHERITANCE_POWER_OF_ATTORNEY',
    PRE_CONTRACTUAL_DOCUMENTATION: 'PRE_CONTRACTUAL_DOCUMENTATION',
    CONTRACTUAL_DOCUMENTATION: 'CONTRACTUAL_DOCUMENTATION',
    EXCEPTION_DOCUMENTATION: 'EXCEPTION_DOCUMENTATION',
    INCOME_DOCUMENTATION: 'INCOME_DOCUMENTATION',
    PROPERTY_DOCUMENTATION: 'PROPERTY_DOCUMENTATION',
    DRAWDOWN_DOCUMENTATION: 'DRAWDOWN_DOCUMENTATION',
    POST_DRAWDOWN_DOCUMENTATION: 'POST_DRAWDOWN_DOCUMENTATION',
    OTHER: 'OTHER'
} as const;

export type ClientDocumentCategoryV5 = typeof ClientDocumentCategoryV5[keyof typeof ClientDocumentCategoryV5];


/**
 * 
 * @export
 * @interface CommitmentsConfirmationRequestV5
 */
export interface CommitmentsConfirmationRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof CommitmentsConfirmationRequestV5
     */
    'tags'?: Array<string>;
    /**
     * Unique identifier of the account
     * @type {string}
     * @memberof CommitmentsConfirmationRequestV5
     */
    'accountUuid': string;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof CommitmentsConfirmationRequestV5
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @interface ComplaintsProcedureRequestV5
 */
export interface ComplaintsProcedureRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof ComplaintsProcedureRequestV5
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof ComplaintsProcedureRequestV5
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @interface DirectDebitConfirmationRequestV5
 */
export interface DirectDebitConfirmationRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof DirectDebitConfirmationRequestV5
     */
    'tags'?: Array<string>;
    /**
     * Unique identifier of the account
     * @type {string}
     * @memberof DirectDebitConfirmationRequestV5
     */
    'accountUuid': string;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof DirectDebitConfirmationRequestV5
     */
    'mediaType': MediaTypeV5;
    /**
     * Unique identifier of the direct debit record
     * @type {string}
     * @memberof DirectDebitConfirmationRequestV5
     */
    'directDebitUuid': string;
}


/**
 * 
 * @export
 * @interface DirectDebitConfirmationRequestV5AllOf
 */
export interface DirectDebitConfirmationRequestV5AllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof DirectDebitConfirmationRequestV5AllOf
     */
    'tags'?: Array<string>;
    /**
     * Unique identifier of the account
     * @type {string}
     * @memberof DirectDebitConfirmationRequestV5AllOf
     */
    'accountUuid': string;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof DirectDebitConfirmationRequestV5AllOf
     */
    'mediaType': MediaTypeV5;
    /**
     * Unique identifier of the direct debit record
     * @type {string}
     * @memberof DirectDebitConfirmationRequestV5AllOf
     */
    'directDebitUuid': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DocumentActionV5 = {
    DOCUMENT_CREATED: 'DOCUMENT_CREATED',
    DOCUMENT_MODIFIED: 'DOCUMENT_MODIFIED',
    ARCHIVATION: 'ARCHIVATION',
    OTHER: 'OTHER'
} as const;

export type DocumentActionV5 = typeof DocumentActionV5[keyof typeof DocumentActionV5];


/**
 * 
 * @export
 * @enum {string}
 */

export const DocumentClassV5 = {
    BANK: 'BANK',
    CLIENT: 'CLIENT'
} as const;

export type DocumentClassV5 = typeof DocumentClassV5[keyof typeof DocumentClassV5];


/**
 * 
 * @export
 * @interface DocumentSearchRequestFilterV5
 */
export interface DocumentSearchRequestFilterV5 {
    /**
     * 
     * @type {boolean}
     * @memberof DocumentSearchRequestFilterV5
     */
    'visibleToClient'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentSearchRequestFilterV5
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {Array<BankDocumentTemplateV5>}
     * @memberof DocumentSearchRequestFilterV5
     */
    'bankDocumentTemplate'?: Array<BankDocumentTemplateV5>;
    /**
     * 
     * @type {Array<ClientDocumentCategoryV5>}
     * @memberof DocumentSearchRequestFilterV5
     */
    'category'?: Array<ClientDocumentCategoryV5>;
    /**
     * 
     * @type {string}
     * @memberof DocumentSearchRequestFilterV5
     */
    'createdFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSearchRequestFilterV5
     */
    'createdTo'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentSearchRequestFilterV5
     */
    'archived'?: boolean;
    /**
     * 
     * @type {DocumentClassV5}
     * @memberof DocumentSearchRequestFilterV5
     */
    'documentType'?: DocumentClassV5;
}


/**
 * 
 * @export
 * @interface ExampleTemplateRequestV5
 */
export interface ExampleTemplateRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof ExampleTemplateRequestV5
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof ExampleTemplateRequestV5
     */
    'mediaType': MediaTypeV5;
}


/**
 * A document (file) with binary content.
 * @export
 * @interface FileDocumentWithContentV5
 */
export interface FileDocumentWithContentV5 {
    /**
     * 
     * @type {UploadClientDocumentInfoV5}
     * @memberof FileDocumentWithContentV5
     */
    'uploadClientDocumentInfo': UploadClientDocumentInfoV5;
    /**
     * 
     * @type {File}
     * @memberof FileDocumentWithContentV5
     */
    'content': File;
}
/**
 * 
 * @export
 * @interface ForeignPoliceConfirmationRequestV5
 */
export interface ForeignPoliceConfirmationRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof ForeignPoliceConfirmationRequestV5
     */
    'tags'?: Array<string>;
    /**
     * Unique identifier of the account
     * @type {string}
     * @memberof ForeignPoliceConfirmationRequestV5
     */
    'accountUuid': string;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof ForeignPoliceConfirmationRequestV5
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @interface FrameworkAgreementAmendmentRequestV5
 */
export interface FrameworkAgreementAmendmentRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof FrameworkAgreementAmendmentRequestV5
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof FrameworkAgreementAmendmentRequestV5
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @interface FrameworkAgreementAmendmentRequestV5AllOf
 */
export interface FrameworkAgreementAmendmentRequestV5AllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof FrameworkAgreementAmendmentRequestV5AllOf
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof FrameworkAgreementAmendmentRequestV5AllOf
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const FrameworkAgreementRequestAccountProductCodeV5 = {
    ACCOUNT_PROTECTED: 'OP_ACCOUNT_PROTECTED',
    CURRENT_ACCOUNT_BASIC: 'OP_CURRENT_ACCOUNT_BASIC',
    CURRENT_ACCOUNT_CHILD: 'OP_CURRENT_ACCOUNT_CHILD',
    CURRENT_ACCOUNT_SECONDARY: 'OP_CURRENT_ACCOUNT_SECONDARY',
    CURRENT_ACCOUNT_SHARED: 'OP_CURRENT_ACCOUNT_SHARED',
    SAVINGS_ACCOUNT_BASIC: 'OP_SAVINGS_ACCOUNT_BASIC',
    SAVINGS_ACCOUNT_CHILD: 'OP_SAVINGS_ACCOUNT_CHILD',
    SAVINGS_ACCOUNT_SHARED: 'OP_SAVINGS_ACCOUNT_SHARED'
} as const;

export type FrameworkAgreementRequestAccountProductCodeV5 = typeof FrameworkAgreementRequestAccountProductCodeV5[keyof typeof FrameworkAgreementRequestAccountProductCodeV5];


/**
 * 
 * @export
 * @enum {string}
 */

export const FrameworkAgreementRequestCardTypeV5 = {
    VIRTUAL: 'VIRTUAL',
    PREMIUM: 'PREMIUM',
    STANDARD: 'STANDARD',
    KIDS: 'KIDS',
    COMMON: 'COMMON',
    DISPOSABLE: 'DISPOSABLE'
} as const;

export type FrameworkAgreementRequestCardTypeV5 = typeof FrameworkAgreementRequestCardTypeV5[keyof typeof FrameworkAgreementRequestCardTypeV5];


/**
 * 
 * @export
 * @interface FrameworkAgreementRequestCardV5
 */
export interface FrameworkAgreementRequestCardV5 {
    /**
     * 
     * @type {FrameworkAgreementRequestCardTypeV5}
     * @memberof FrameworkAgreementRequestCardV5
     */
    'type': FrameworkAgreementRequestCardTypeV5;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const FrameworkAgreementRequestOriginV5 = {
    MA: 'MA',
    FAA: 'FAA'
} as const;

export type FrameworkAgreementRequestOriginV5 = typeof FrameworkAgreementRequestOriginV5[keyof typeof FrameworkAgreementRequestOriginV5];


/**
 * 
 * @export
 * @interface FrameworkAgreementRequestV5
 */
export interface FrameworkAgreementRequestV5 {
    /**
     * Unique identifier of the application
     * @type {string}
     * @memberof FrameworkAgreementRequestV5
     */
    'applicationUuid': string;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof FrameworkAgreementRequestV5
     */
    'mediaType': MediaTypeV5;
    /**
     * 
     * @type {Array<string>}
     * @memberof FrameworkAgreementRequestV5
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {FrameworkAgreementRequestOriginV5}
     * @memberof FrameworkAgreementRequestV5
     */
    'origin'?: FrameworkAgreementRequestOriginV5;
    /**
     * 
     * @type {FrameworkAgreementRequestAccountProductCodeV5}
     * @memberof FrameworkAgreementRequestV5
     */
    'accountProductCode'?: FrameworkAgreementRequestAccountProductCodeV5;
    /**
     * 
     * @type {string}
     * @memberof FrameworkAgreementRequestV5
     */
    'accountNumber'?: string;
    /**
     * 
     * @type {Array<FrameworkAgreementRequestCardV5>}
     * @memberof FrameworkAgreementRequestV5
     */
    'cards'?: Array<FrameworkAgreementRequestCardV5>;
}


/**
 * 
 * @export
 * @interface FrameworkAgreementRequestV5AllOf
 */
export interface FrameworkAgreementRequestV5AllOf {
    /**
     * Unique identifier of the application
     * @type {string}
     * @memberof FrameworkAgreementRequestV5AllOf
     */
    'applicationUuid': string;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof FrameworkAgreementRequestV5AllOf
     */
    'mediaType': MediaTypeV5;
    /**
     * 
     * @type {Array<string>}
     * @memberof FrameworkAgreementRequestV5AllOf
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {FrameworkAgreementRequestOriginV5}
     * @memberof FrameworkAgreementRequestV5AllOf
     */
    'origin'?: FrameworkAgreementRequestOriginV5;
    /**
     * 
     * @type {FrameworkAgreementRequestAccountProductCodeV5}
     * @memberof FrameworkAgreementRequestV5AllOf
     */
    'accountProductCode'?: FrameworkAgreementRequestAccountProductCodeV5;
    /**
     * 
     * @type {string}
     * @memberof FrameworkAgreementRequestV5AllOf
     */
    'accountNumber'?: string;
    /**
     * 
     * @type {Array<FrameworkAgreementRequestCardV5>}
     * @memberof FrameworkAgreementRequestV5AllOf
     */
    'cards'?: Array<FrameworkAgreementRequestCardV5>;
}


/**
 * @type GenerateBankDocumentRequestV5
 * @export
 */
export type GenerateBankDocumentRequestV5 = { bankDocumentType: 'ACCOUNT_TERMINATION_BANK_IMMEDIATE_CAB' } & AccountTerminationBankImmediateCabRequestV5 | { bankDocumentType: 'ACCOUNT_TERMINATION_BANK_IMMEDIATE_OTHER' } & AccountTerminationBankImmediateOtherRequestV5 | { bankDocumentType: 'ACCOUNT_TERMINATION_BANK_WITH_NOTICE_PERIOD' } & AccountTerminationBankWithNoticePeriodRequestV5 | { bankDocumentType: 'ACCOUNT_TERMINATION_LIMITATION_OF_AUTONOMY' } & AccountTerminationLimitationOfAutonomyRequestV5 | { bankDocumentType: 'ADDENDUM_TO_FRAMEWORK_AGREEMENT' } & AddendumToFrameworkAgreementRequestV5 | { bankDocumentType: 'AVAILABLE_ACCOUNT_CONFIRMATION' } & AvailableAccountConfirmationRequestV5 | { bankDocumentType: 'AVAILABLE_BALANCE_CONFIRMATION' } & AvailableBalanceConfirmationRequestV5 | { bankDocumentType: 'COMMITMENTS_CONFIRMATION' } & CommitmentsConfirmationRequestV5 | { bankDocumentType: 'COMPLAINTS_PROCEDURE' } & ComplaintsProcedureRequestV5 | { bankDocumentType: 'DIRECT_DEBIT_CONFIRMATION' } & DirectDebitConfirmationRequestV5 | { bankDocumentType: 'EXAMPLE' } & ExampleTemplateRequestV5 | { bankDocumentType: 'FOREIGN_POLICE_CONFIRMATION' } & ForeignPoliceConfirmationRequestV5 | { bankDocumentType: 'FRAMEWORK_AGREEMENT' } & FrameworkAgreementRequestV5 | { bankDocumentType: 'FRAMEWORK_AGREEMENT_AMENDMENT' } & FrameworkAgreementAmendmentRequestV5 | { bankDocumentType: 'GROUP_MARKETING_CONSENT' } & GroupMarketingConsentRequestV5 | { bankDocumentType: 'INFORMATION_ON_THE_DEPOSIT_INSURANCE_SYSTEM' } & InformationDepositInsuranceSystemRequestV5 | { bankDocumentType: 'INTEREST_RATES' } & InterestRatesRequestV5 | { bankDocumentType: 'MOBILITY_REQUEST' } & MobilityRequestRequestV5 | { bankDocumentType: 'PERMANENTLY_ACCESSIBLE_INFORMATION' } & PermanentlyAccessibleInformationRequestV5 | { bankDocumentType: 'PERSONAL_DATA_PROCESSING_INFORMATION' } & PersonalDataProcessingInformationRequestV5 | { bankDocumentType: 'PRICE_LIST' } & PriceListRequestV5 | { bankDocumentType: 'PRICE_LIST_AMENDMENT' } & PriceListAmendmentRequestV5 | { bankDocumentType: 'SIPO_CONFIRMATION' } & SipoConfirmationRequestV5 | { bankDocumentType: 'STANDING_ORDER_CONFIRMATION' } & StandingOrderConfirmationRequestV5 | { bankDocumentType: 'STATEMENT_OF_FEES' } & StatementOfFeesRequestV5 | { bankDocumentType: 'STATEMENT_OF_PAYMENTS' } & StatementOfPaymentsRequestV5 | { bankDocumentType: 'TERMS_AND_CONDITIONS' } & TermsAndConditionsRequestV5 | { bankDocumentType: 'TERMS_AND_CONDITIONS_ADJUSTMENT' } & TermsAndConditionsAdjustmentRequestV5 | { bankDocumentType: 'TERMS_AND_CONDITIONS_AMENDMENT' } & TermsAndConditionsAmendmentRequestV5 | { bankDocumentType: 'TERMS_AND_CONDITIONS_CARDS' } & TermsAndConditionsCardsRequestV5 | { bankDocumentType: 'TERMS_AND_CONDITIONS_CARDS_ADJUSTMENT' } & TermsAndConditionsCardsAdjustmentRequestV5 | { bankDocumentType: 'TERMS_AND_CONDITIONS_CARDS_AMENDMENT' } & TermsAndConditionsCardsAmendmentRequestV5 | { bankDocumentType: 'TERMS_AND_CONDITIONS_CARDS_GOOGLE_AND_APPLE_PAY' } & TermsAndConditionsCardsGoogleAndApplePayRequestV5 | { bankDocumentType: 'TERMS_AND_CONDITIONS_PAYMENTS' } & TermsAndConditionsPaymentsRequestV5 | { bankDocumentType: 'TERMS_AND_CONDITIONS_PAYMENTS_ADJUSTMENT' } & TermsAndConditionsPaymentsAdjustmentRequestV5 | { bankDocumentType: 'TERMS_AND_CONDITIONS_PAYMENTS_AMENDMENT' } & TermsAndConditionsPaymentsAmendmentRequestV5 | { bankDocumentType: 'TERMS_OF_USE_MOBILE_APPLICATION' } & TermsOfUseMobileApplicationRequestV5 | { bankDocumentType: 'TRANSACTION_CONFIRMATION' } & TransactionConfirmationRequestV5;

/**
 * 
 * @export
 * @interface GenerateBankDocumentResponseV5
 */
export interface GenerateBankDocumentResponseV5 {
    /**
     * Unique identifier of the bank document
     * @type {string}
     * @memberof GenerateBankDocumentResponseV5
     */
    'bankDocumentUuid': string;
    /**
     * 
     * @type {BankDocumentTypeV5}
     * @memberof GenerateBankDocumentResponseV5
     */
    'bankDocumentType': BankDocumentTypeV5;
    /**
     * 
     * @type {string}
     * @memberof GenerateBankDocumentResponseV5
     */
    'fileName': string;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof GenerateBankDocumentResponseV5
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @interface GetAvailableDocumentsResponseV5
 */
export interface GetAvailableDocumentsResponseV5 {
    /**
     * 
     * @type {Array<BankDocumentTemplateV5>}
     * @memberof GetAvailableDocumentsResponseV5
     */
    'bankDocumentTemplates': Array<BankDocumentTemplateV5>;
    /**
     * 
     * @type {Array<ClientDocumentCategoryV5>}
     * @memberof GetAvailableDocumentsResponseV5
     */
    'clientDocumentTemplates': Array<ClientDocumentCategoryV5>;
}
/**
 * 
 * @export
 * @interface GetDocumentAuditLogResponseDocumentArchivedV5
 */
export interface GetDocumentAuditLogResponseDocumentArchivedV5 {
    /**
     * 
     * @type {string}
     * @memberof GetDocumentAuditLogResponseDocumentArchivedV5
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface GetDocumentAuditLogResponseDocumentArchivedV5AllOf
 */
export interface GetDocumentAuditLogResponseDocumentArchivedV5AllOf {
    /**
     * 
     * @type {string}
     * @memberof GetDocumentAuditLogResponseDocumentArchivedV5AllOf
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface GetDocumentAuditLogResponseDocumentCreatedV5
 */
export interface GetDocumentAuditLogResponseDocumentCreatedV5 {
}
/**
 * 
 * @export
 * @interface GetDocumentAuditLogResponseDocumentModifiedV5
 */
export interface GetDocumentAuditLogResponseDocumentModifiedV5 {
    /**
     * 
     * @type {GetDocumentAuditLogResponseModificationDataV5}
     * @memberof GetDocumentAuditLogResponseDocumentModifiedV5
     */
    'oldObject': GetDocumentAuditLogResponseModificationDataV5;
    /**
     * 
     * @type {GetDocumentAuditLogResponseModificationDataV5}
     * @memberof GetDocumentAuditLogResponseDocumentModifiedV5
     */
    'newObject': GetDocumentAuditLogResponseModificationDataV5;
    /**
     * 
     * @type {string}
     * @memberof GetDocumentAuditLogResponseDocumentModifiedV5
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface GetDocumentAuditLogResponseDocumentModifiedV5AllOf
 */
export interface GetDocumentAuditLogResponseDocumentModifiedV5AllOf {
    /**
     * 
     * @type {GetDocumentAuditLogResponseModificationDataV5}
     * @memberof GetDocumentAuditLogResponseDocumentModifiedV5AllOf
     */
    'oldObject': GetDocumentAuditLogResponseModificationDataV5;
    /**
     * 
     * @type {GetDocumentAuditLogResponseModificationDataV5}
     * @memberof GetDocumentAuditLogResponseDocumentModifiedV5AllOf
     */
    'newObject': GetDocumentAuditLogResponseModificationDataV5;
    /**
     * 
     * @type {string}
     * @memberof GetDocumentAuditLogResponseDocumentModifiedV5AllOf
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface GetDocumentAuditLogResponseDocumentOtherV5
 */
export interface GetDocumentAuditLogResponseDocumentOtherV5 {
}
/**
 * @type GetDocumentAuditLogResponseGenericV5
 * @export
 */
export type GetDocumentAuditLogResponseGenericV5 = { action: 'ARCHIVATION' } & GetDocumentAuditLogResponseDocumentArchivedV5 | { action: 'DOCUMENT_CREATED' } & GetDocumentAuditLogResponseDocumentCreatedV5 | { action: 'DOCUMENT_MODIFIED' } & GetDocumentAuditLogResponseDocumentModifiedV5 | { action: 'OTHER' } & GetDocumentAuditLogResponseDocumentOtherV5;

/**
 * 
 * @export
 * @interface GetDocumentAuditLogResponseModificationDataV5
 */
export interface GetDocumentAuditLogResponseModificationDataV5 {
    /**
     * 
     * @type {boolean}
     * @memberof GetDocumentAuditLogResponseModificationDataV5
     */
    'visibleToClient'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetDocumentAuditLogResponseModificationDataV5
     */
    'owningPidUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDocumentAuditLogResponseModificationDataV5
     */
    'accountUuid'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDocumentAuditLogResponseModificationDataV5
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetDocumentAuditLogResponseModificationDataV5
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDocumentAuditLogResponseModificationDataV5
     */
    'documentType'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDocumentAuditLogResponseModificationDataV5
     */
    'fileName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetDocumentAuditLogResponseModificationDataV5
     */
    'availableToClient'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetDocumentAuditLogResponseModificationDataV5
     */
    'documentInfo'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDocumentAuditLogResponseModificationDataV5
     */
    'effectiveFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDocumentAuditLogResponseModificationDataV5
     */
    'documentCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDocumentAuditLogResponseModificationDataV5
     */
    'expireAt'?: string;
}
/**
 * 
 * @export
 * @interface GetDocumentAuditLogResponseV5
 */
export interface GetDocumentAuditLogResponseV5 {
    /**
     * 
     * @type {Array<GetDocumentAuditLogResponseGenericV5>}
     * @memberof GetDocumentAuditLogResponseV5
     */
    'auditLog'?: Array<GetDocumentAuditLogResponseGenericV5>;
}
/**
 * 
 * @export
 * @interface GroupMarketingConsentRequestV5
 */
export interface GroupMarketingConsentRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof GroupMarketingConsentRequestV5
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof GroupMarketingConsentRequestV5
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @interface InformationDepositInsuranceSystemRequestV5
 */
export interface InformationDepositInsuranceSystemRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof InformationDepositInsuranceSystemRequestV5
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof InformationDepositInsuranceSystemRequestV5
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @interface InterestRatesRequestV5
 */
export interface InterestRatesRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof InterestRatesRequestV5
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof InterestRatesRequestV5
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const MediaTypeV5 = {
    APPLICATION_PDF: 'application/pdf',
    TEXT_CSV: 'text/csv'
} as const;

export type MediaTypeV5 = typeof MediaTypeV5[keyof typeof MediaTypeV5];


/**
 * 
 * @export
 * @interface MobilityRequestRequestV5
 */
export interface MobilityRequestRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof MobilityRequestRequestV5
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof MobilityRequestRequestV5
     */
    'mediaType': MediaTypeV5;
    /**
     * 
     * @type {string}
     * @memberof MobilityRequestRequestV5
     */
    'mobilityUuid': string;
}


/**
 * 
 * @export
 * @interface MobilityRequestRequestV5AllOf
 */
export interface MobilityRequestRequestV5AllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof MobilityRequestRequestV5AllOf
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof MobilityRequestRequestV5AllOf
     */
    'mediaType': MediaTypeV5;
    /**
     * 
     * @type {string}
     * @memberof MobilityRequestRequestV5AllOf
     */
    'mobilityUuid': string;
}


/**
 * A client document modification
 * @export
 * @interface ModifyClientDocumentMetadataRequestV5
 */
export interface ModifyClientDocumentMetadataRequestV5 {
    /**
     * 
     * @type {ClientDocumentCategoryV5}
     * @memberof ModifyClientDocumentMetadataRequestV5
     */
    'category': ClientDocumentCategoryV5;
    /**
     * 
     * @type {Array<string>}
     * @memberof ModifyClientDocumentMetadataRequestV5
     */
    'tags': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ModifyClientDocumentMetadataRequestV5
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof ModifyClientDocumentMetadataRequestV5
     */
    'documentInfo': string;
    /**
     * 
     * @type {boolean}
     * @memberof ModifyClientDocumentMetadataRequestV5
     */
    'visibleToClient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ModifyClientDocumentMetadataRequestV5
     */
    'owningPidUuid': string;
    /**
     * 
     * @type {string}
     * @memberof ModifyClientDocumentMetadataRequestV5
     */
    'accountUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModifyClientDocumentMetadataRequestV5
     */
    'effectiveFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModifyClientDocumentMetadataRequestV5
     */
    'reason'?: string;
}


/**
 * A client document modification response
 * @export
 * @interface ModifyClientDocumentMetadataResponseV5
 */
export interface ModifyClientDocumentMetadataResponseV5 {
    /**
     * 
     * @type {string}
     * @memberof ModifyClientDocumentMetadataResponseV5
     */
    'clientDocumentUuid': string;
}
/**
 * 
 * @export
 * @interface OriginalDocumentV5
 */
export interface OriginalDocumentV5 {
    /**
     * 
     * @type {string}
     * @memberof OriginalDocumentV5
     */
    'originalDocumentUuid': string;
    /**
     * 
     * @type {string}
     * @memberof OriginalDocumentV5
     */
    'fileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof OriginalDocumentV5
     */
    'createdAt'?: string;
}
/**
 * Pagaeble object used for searching. Returns the state of pagination.
 * @export
 * @interface PageableResponseV1x0
 */
export interface PageableResponseV1x0 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'pageNumber': number;
    /**
     * Number of records per page.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'pageSize': number;
    /**
     * Total number of pages with this page size.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'totalPages': number;
    /**
     * Total size of all records.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'totalSize': number;
}
/**
 * Object for search paging.
 * @export
 * @interface PageableV1x0
 */
export interface PageableV1x0 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableV1x0
     */
    'pageNumber': number;
    /**
     * Maximum number of records per page.
     * @type {number}
     * @memberof PageableV1x0
     */
    'pageSize': number;
}
/**
 * 
 * @export
 * @interface PermanentlyAccessibleInformationRequestV5
 */
export interface PermanentlyAccessibleInformationRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof PermanentlyAccessibleInformationRequestV5
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof PermanentlyAccessibleInformationRequestV5
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @interface PersonalDataProcessingInformationRequestV5
 */
export interface PersonalDataProcessingInformationRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof PersonalDataProcessingInformationRequestV5
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof PersonalDataProcessingInformationRequestV5
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @interface PriceListAmendmentRequestV5
 */
export interface PriceListAmendmentRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof PriceListAmendmentRequestV5
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof PriceListAmendmentRequestV5
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @interface PriceListRequestV5
 */
export interface PriceListRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof PriceListRequestV5
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof PriceListRequestV5
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @interface SearchDocumentsRequestV5
 */
export interface SearchDocumentsRequestV5 {
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsRequestV5
     */
    'pidUuid': string;
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsRequestV5
     */
    'searchFileName'?: string;
    /**
     * 
     * @type {DocumentSearchRequestFilterV5}
     * @memberof SearchDocumentsRequestV5
     */
    'filter': DocumentSearchRequestFilterV5;
    /**
     * 
     * @type {PageableV1x0}
     * @memberof SearchDocumentsRequestV5
     */
    'pageable'?: PageableV1x0;
}
/**
 * 
 * @export
 * @interface SearchDocumentsResponseBankDocumentV5
 */
export interface SearchDocumentsResponseBankDocumentV5 {
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseBankDocumentV5
     */
    'bankDocumentUuid': string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchDocumentsResponseBankDocumentV5
     */
    'visible'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseBankDocumentV5
     */
    'bankDocumentCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseBankDocumentV5
     */
    'ownerPidUuid': string;
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseBankDocumentV5
     */
    'accountUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseBankDocumentV5
     */
    'fileName': string;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof SearchDocumentsResponseBankDocumentV5
     */
    'mediaType': MediaTypeV5;
    /**
     * 
     * @type {BankDocumentTemplateV5}
     * @memberof SearchDocumentsResponseBankDocumentV5
     */
    'bankDocumentTemplate': BankDocumentTemplateV5;
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseBankDocumentV5
     */
    'collectedDataType': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchDocumentsResponseBankDocumentV5
     */
    'tags': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseBankDocumentV5
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseBankDocumentV5
     */
    'expiredAt': string;
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseBankDocumentV5
     */
    'effectiveFrom'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchDocumentsResponseBankDocumentV5
     */
    'archived': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchDocumentsResponseBankDocumentV5
     */
    'visibleToClient'?: boolean;
}


/**
 * 
 * @export
 * @interface SearchDocumentsResponseBankDocumentV5AllOf
 */
export interface SearchDocumentsResponseBankDocumentV5AllOf {
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseBankDocumentV5AllOf
     */
    'bankDocumentUuid'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchDocumentsResponseBankDocumentV5AllOf
     */
    'visible'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseBankDocumentV5AllOf
     */
    'bankDocumentCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseBankDocumentV5AllOf
     */
    'ownerPidUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseBankDocumentV5AllOf
     */
    'accountUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseBankDocumentV5AllOf
     */
    'fileName'?: string;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof SearchDocumentsResponseBankDocumentV5AllOf
     */
    'mediaType'?: MediaTypeV5;
    /**
     * 
     * @type {BankDocumentTemplateV5}
     * @memberof SearchDocumentsResponseBankDocumentV5AllOf
     */
    'bankDocumentTemplate'?: BankDocumentTemplateV5;
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseBankDocumentV5AllOf
     */
    'collectedDataType'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchDocumentsResponseBankDocumentV5AllOf
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseBankDocumentV5AllOf
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseBankDocumentV5AllOf
     */
    'expiredAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseBankDocumentV5AllOf
     */
    'effectiveFrom'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchDocumentsResponseBankDocumentV5AllOf
     */
    'archived'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchDocumentsResponseBankDocumentV5AllOf
     */
    'visibleToClient'?: boolean;
}


/**
 * 
 * @export
 * @interface SearchDocumentsResponseClientDocumentV5
 */
export interface SearchDocumentsResponseClientDocumentV5 {
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseClientDocumentV5
     */
    'clientDocumentUuid': string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchDocumentsResponseClientDocumentV5
     */
    'visible'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseClientDocumentV5
     */
    'owningPidUuid': string;
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseClientDocumentV5
     */
    'accountUuid'?: string;
    /**
     * 
     * @type {ClientDocumentCategoryV5}
     * @memberof SearchDocumentsResponseClientDocumentV5
     */
    'category': ClientDocumentCategoryV5;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchDocumentsResponseClientDocumentV5
     */
    'tags': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseClientDocumentV5
     */
    'fileName': string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchDocumentsResponseClientDocumentV5
     */
    'availableToClient': boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseClientDocumentV5
     */
    'documentInfo'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseClientDocumentV5
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseClientDocumentV5
     */
    'effectiveFrom'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchDocumentsResponseClientDocumentV5
     */
    'archived': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchDocumentsResponseClientDocumentV5
     */
    'visibleToClient'?: boolean;
}


/**
 * 
 * @export
 * @interface SearchDocumentsResponseClientDocumentV5AllOf
 */
export interface SearchDocumentsResponseClientDocumentV5AllOf {
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseClientDocumentV5AllOf
     */
    'clientDocumentUuid'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchDocumentsResponseClientDocumentV5AllOf
     */
    'visible'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseClientDocumentV5AllOf
     */
    'owningPidUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseClientDocumentV5AllOf
     */
    'accountUuid'?: string;
    /**
     * 
     * @type {ClientDocumentCategoryV5}
     * @memberof SearchDocumentsResponseClientDocumentV5AllOf
     */
    'category'?: ClientDocumentCategoryV5;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchDocumentsResponseClientDocumentV5AllOf
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseClientDocumentV5AllOf
     */
    'fileName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchDocumentsResponseClientDocumentV5AllOf
     */
    'availableToClient'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseClientDocumentV5AllOf
     */
    'documentInfo'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseClientDocumentV5AllOf
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchDocumentsResponseClientDocumentV5AllOf
     */
    'effectiveFrom'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchDocumentsResponseClientDocumentV5AllOf
     */
    'archived'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchDocumentsResponseClientDocumentV5AllOf
     */
    'visibleToClient'?: boolean;
}


/**
 * @type SearchDocumentsResponseGenericDocumentV5
 * @export
 */
export type SearchDocumentsResponseGenericDocumentV5 = { type: 'BANK' } & SearchDocumentsResponseBankDocumentV5 | { type: 'CLIENT' } & SearchDocumentsResponseClientDocumentV5;

/**
 * 
 * @export
 * @interface SearchDocumentsResponseV5
 */
export interface SearchDocumentsResponseV5 {
    /**
     * 
     * @type {Array<SearchDocumentsResponseGenericDocumentV5>}
     * @memberof SearchDocumentsResponseV5
     */
    'documents': Array<SearchDocumentsResponseGenericDocumentV5>;
    /**
     * 
     * @type {PageableResponseV1x0}
     * @memberof SearchDocumentsResponseV5
     */
    'pageable': PageableResponseV1x0;
}
/**
 * A request to send contract documents to Prometheus.
 * @export
 * @interface SendDocumentsRequestV5
 */
export interface SendDocumentsRequestV5 {
    /**
     * Unique identifier of a user (Partners identity)
     * @type {string}
     * @memberof SendDocumentsRequestV5
     */
    'clientPidUuid': string;
    /**
     * PFS ID of an advisor.
     * @type {number}
     * @memberof SendDocumentsRequestV5
     */
    'advisorId'?: number;
}
/**
 * A response to sending contract documents to Prometheus.
 * @export
 * @interface SendDocumentsResponseV5
 */
export interface SendDocumentsResponseV5 {
    /**
     * PFS ID of an advisor.
     * @type {number}
     * @memberof SendDocumentsResponseV5
     */
    'advisorId'?: number;
}
/**
 * 
 * @export
 * @interface SetDocumentVisibilityRequestV5
 */
export interface SetDocumentVisibilityRequestV5 {
    /**
     * Document visibility
     * @type {boolean}
     * @memberof SetDocumentVisibilityRequestV5
     */
    'visible': boolean;
}
/**
 * Type of signature subject, refers to category of signature that\'s present on templates. Aggregate of BankSignatureSubjectType and ClientSignatureSubjectType
 * @export
 * @enum {string}
 */

export const SignatureSubjectTypeV5 = {
    CLIENT: 'CLIENT',
    BANK: 'BANK'
} as const;

export type SignatureSubjectTypeV5 = typeof SignatureSubjectTypeV5[keyof typeof SignatureSubjectTypeV5];


/**
 * 
 * @export
 * @interface SignatureV5
 */
export interface SignatureV5 {
    /**
     * 
     * @type {SignatureSubjectTypeV5}
     * @memberof SignatureV5
     */
    'signatureSubjectType': SignatureSubjectTypeV5;
    /**
     * Optional pidUuid of bank employee that signs the document
     * @type {string}
     * @memberof SignatureV5
     */
    'pidUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignatureV5
     */
    'signatureDate': string;
    /**
     * Full name of the person that signed the document
     * @type {string}
     * @memberof SignatureV5
     */
    'fullName'?: string;
}


/**
 * 
 * @export
 * @interface SipoConfirmationRequestV5
 */
export interface SipoConfirmationRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof SipoConfirmationRequestV5
     */
    'tags'?: Array<string>;
    /**
     * Unique identifier of the account
     * @type {string}
     * @memberof SipoConfirmationRequestV5
     */
    'accountUuid': string;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof SipoConfirmationRequestV5
     */
    'mediaType': MediaTypeV5;
    /**
     * Unique identifier of the SIPO
     * @type {string}
     * @memberof SipoConfirmationRequestV5
     */
    'sipoUuid': string;
}


/**
 * 
 * @export
 * @interface SipoConfirmationRequestV5AllOf
 */
export interface SipoConfirmationRequestV5AllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof SipoConfirmationRequestV5AllOf
     */
    'tags'?: Array<string>;
    /**
     * Unique identifier of the account
     * @type {string}
     * @memberof SipoConfirmationRequestV5AllOf
     */
    'accountUuid': string;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof SipoConfirmationRequestV5AllOf
     */
    'mediaType': MediaTypeV5;
    /**
     * Unique identifier of the SIPO
     * @type {string}
     * @memberof SipoConfirmationRequestV5AllOf
     */
    'sipoUuid': string;
}


/**
 * 
 * @export
 * @interface StandingOrderConfirmationRequestV5
 */
export interface StandingOrderConfirmationRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof StandingOrderConfirmationRequestV5
     */
    'tags'?: Array<string>;
    /**
     * Unique identifier of the account
     * @type {string}
     * @memberof StandingOrderConfirmationRequestV5
     */
    'accountUuid': string;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof StandingOrderConfirmationRequestV5
     */
    'mediaType': MediaTypeV5;
    /**
     * Unique identifier of the standing order record
     * @type {string}
     * @memberof StandingOrderConfirmationRequestV5
     */
    'standingOrderUuid': string;
}


/**
 * 
 * @export
 * @interface StandingOrderConfirmationRequestV5AllOf
 */
export interface StandingOrderConfirmationRequestV5AllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof StandingOrderConfirmationRequestV5AllOf
     */
    'tags'?: Array<string>;
    /**
     * Unique identifier of the account
     * @type {string}
     * @memberof StandingOrderConfirmationRequestV5AllOf
     */
    'accountUuid': string;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof StandingOrderConfirmationRequestV5AllOf
     */
    'mediaType': MediaTypeV5;
    /**
     * Unique identifier of the standing order record
     * @type {string}
     * @memberof StandingOrderConfirmationRequestV5AllOf
     */
    'standingOrderUuid': string;
}


/**
 * 
 * @export
 * @interface StatementOfFeesRequestV5
 */
export interface StatementOfFeesRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof StatementOfFeesRequestV5
     */
    'tags'?: Array<string>;
    /**
     * Unique identifier of the account
     * @type {string}
     * @memberof StatementOfFeesRequestV5
     */
    'accountUuid': string;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof StatementOfFeesRequestV5
     */
    'mediaType': MediaTypeV5;
    /**
     * 
     * @type {number}
     * @memberof StatementOfFeesRequestV5
     */
    'year': number;
}


/**
 * 
 * @export
 * @interface StatementOfFeesRequestV5AllOf
 */
export interface StatementOfFeesRequestV5AllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof StatementOfFeesRequestV5AllOf
     */
    'tags'?: Array<string>;
    /**
     * Unique identifier of the account
     * @type {string}
     * @memberof StatementOfFeesRequestV5AllOf
     */
    'accountUuid': string;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof StatementOfFeesRequestV5AllOf
     */
    'mediaType': MediaTypeV5;
    /**
     * 
     * @type {number}
     * @memberof StatementOfFeesRequestV5AllOf
     */
    'year': number;
}


/**
 * 
 * @export
 * @interface StatementOfPaymentsRequestV5
 */
export interface StatementOfPaymentsRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof StatementOfPaymentsRequestV5
     */
    'tags'?: Array<string>;
    /**
     * Unique identifier of the account
     * @type {string}
     * @memberof StatementOfPaymentsRequestV5
     */
    'accountUuid': string;
    /**
     * 
     * @type {string}
     * @memberof StatementOfPaymentsRequestV5
     */
    'accountCurrency': string;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof StatementOfPaymentsRequestV5
     */
    'mediaType': MediaTypeV5;
    /**
     * Date from (minimum date is the start of the Bank or max. 36 months back)
     * @type {string}
     * @memberof StatementOfPaymentsRequestV5
     */
    'from': string;
    /**
     * Date to (past or current date, cannot be less than \'from\')
     * @type {string}
     * @memberof StatementOfPaymentsRequestV5
     */
    'to': string;
}


/**
 * 
 * @export
 * @interface StatementOfPaymentsRequestV5AllOf
 */
export interface StatementOfPaymentsRequestV5AllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof StatementOfPaymentsRequestV5AllOf
     */
    'tags'?: Array<string>;
    /**
     * Unique identifier of the account
     * @type {string}
     * @memberof StatementOfPaymentsRequestV5AllOf
     */
    'accountUuid': string;
    /**
     * 
     * @type {string}
     * @memberof StatementOfPaymentsRequestV5AllOf
     */
    'accountCurrency': string;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof StatementOfPaymentsRequestV5AllOf
     */
    'mediaType': MediaTypeV5;
    /**
     * Date from (minimum date is the start of the Bank or max. 36 months back)
     * @type {string}
     * @memberof StatementOfPaymentsRequestV5AllOf
     */
    'from': string;
    /**
     * Date to (past or current date, cannot be less than \'from\')
     * @type {string}
     * @memberof StatementOfPaymentsRequestV5AllOf
     */
    'to': string;
}


/**
 * 
 * @export
 * @interface TermsAndConditionsAdjustmentRequestV5
 */
export interface TermsAndConditionsAdjustmentRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof TermsAndConditionsAdjustmentRequestV5
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof TermsAndConditionsAdjustmentRequestV5
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @interface TermsAndConditionsAmendmentRequestV5
 */
export interface TermsAndConditionsAmendmentRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof TermsAndConditionsAmendmentRequestV5
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof TermsAndConditionsAmendmentRequestV5
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @interface TermsAndConditionsCardsAdjustmentRequestV5
 */
export interface TermsAndConditionsCardsAdjustmentRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof TermsAndConditionsCardsAdjustmentRequestV5
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof TermsAndConditionsCardsAdjustmentRequestV5
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @interface TermsAndConditionsCardsAmendmentRequestV5
 */
export interface TermsAndConditionsCardsAmendmentRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof TermsAndConditionsCardsAmendmentRequestV5
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof TermsAndConditionsCardsAmendmentRequestV5
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @interface TermsAndConditionsCardsGoogleAndApplePayRequestV5
 */
export interface TermsAndConditionsCardsGoogleAndApplePayRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof TermsAndConditionsCardsGoogleAndApplePayRequestV5
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof TermsAndConditionsCardsGoogleAndApplePayRequestV5
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @interface TermsAndConditionsCardsRequestV5
 */
export interface TermsAndConditionsCardsRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof TermsAndConditionsCardsRequestV5
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof TermsAndConditionsCardsRequestV5
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @interface TermsAndConditionsPaymentsAdjustmentRequestV5
 */
export interface TermsAndConditionsPaymentsAdjustmentRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof TermsAndConditionsPaymentsAdjustmentRequestV5
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof TermsAndConditionsPaymentsAdjustmentRequestV5
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @interface TermsAndConditionsPaymentsAmendmentRequestV5
 */
export interface TermsAndConditionsPaymentsAmendmentRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof TermsAndConditionsPaymentsAmendmentRequestV5
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof TermsAndConditionsPaymentsAmendmentRequestV5
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @interface TermsAndConditionsPaymentsRequestV5
 */
export interface TermsAndConditionsPaymentsRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof TermsAndConditionsPaymentsRequestV5
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof TermsAndConditionsPaymentsRequestV5
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @interface TermsAndConditionsRequestV5
 */
export interface TermsAndConditionsRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof TermsAndConditionsRequestV5
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof TermsAndConditionsRequestV5
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @interface TermsOfUseMobileApplicationRequestV5
 */
export interface TermsOfUseMobileApplicationRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof TermsOfUseMobileApplicationRequestV5
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof TermsOfUseMobileApplicationRequestV5
     */
    'mediaType': MediaTypeV5;
}


/**
 * 
 * @export
 * @interface TransactionConfirmationRequestV5
 */
export interface TransactionConfirmationRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof TransactionConfirmationRequestV5
     */
    'tags'?: Array<string>;
    /**
     * Unique identifier of the account
     * @type {string}
     * @memberof TransactionConfirmationRequestV5
     */
    'accountUuid': string;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof TransactionConfirmationRequestV5
     */
    'mediaType': MediaTypeV5;
    /**
     * Unique identifier of the transaction record
     * @type {string}
     * @memberof TransactionConfirmationRequestV5
     */
    'transactionUuid': string;
}


/**
 * 
 * @export
 * @interface TransactionConfirmationRequestV5AllOf
 */
export interface TransactionConfirmationRequestV5AllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof TransactionConfirmationRequestV5AllOf
     */
    'tags'?: Array<string>;
    /**
     * Unique identifier of the account
     * @type {string}
     * @memberof TransactionConfirmationRequestV5AllOf
     */
    'accountUuid': string;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof TransactionConfirmationRequestV5AllOf
     */
    'mediaType': MediaTypeV5;
    /**
     * Unique identifier of the transaction record
     * @type {string}
     * @memberof TransactionConfirmationRequestV5AllOf
     */
    'transactionUuid': string;
}


/**
 * 
 * @export
 * @interface UploadClientDocumentInfoV5
 */
export interface UploadClientDocumentInfoV5 {
    /**
     * 
     * @type {ClientDocumentCategoryV5}
     * @memberof UploadClientDocumentInfoV5
     */
    'category': ClientDocumentCategoryV5;
    /**
     * 
     * @type {Array<string>}
     * @memberof UploadClientDocumentInfoV5
     */
    'tags': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UploadClientDocumentInfoV5
     */
    'documentInfo': string;
    /**
     * 
     * @type {boolean}
     * @memberof UploadClientDocumentInfoV5
     */
    'availableToClient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UploadClientDocumentInfoV5
     */
    'visibleToClient': boolean;
    /**
     * 
     * @type {string}
     * @memberof UploadClientDocumentInfoV5
     */
    'owningPidUuid': string;
    /**
     * 
     * @type {string}
     * @memberof UploadClientDocumentInfoV5
     */
    'accountUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadClientDocumentInfoV5
     */
    'effectiveFrom'?: string;
}


/**
 * 
 * @export
 * @interface UploadClientDocumentResponseV5
 */
export interface UploadClientDocumentResponseV5 {
    /**
     * 
     * @type {string}
     * @memberof UploadClientDocumentResponseV5
     */
    'clientDocumentUuid': string;
    /**
     * 
     * @type {string}
     * @memberof UploadClientDocumentResponseV5
     */
    'fileName': string;
    /**
     * 
     * @type {MediaTypeV5}
     * @memberof UploadClientDocumentResponseV5
     */
    'mediaType': MediaTypeV5;
}


/**
 * A response to validate request for send contract documents to Prometheus.
 * @export
 * @interface ValidateSendDocumentsResponseV5
 */
export interface ValidateSendDocumentsResponseV5 {
    /**
     * 
     * @type {ValidateSendDocumentsResponseV5Advisor}
     * @memberof ValidateSendDocumentsResponseV5
     */
    'advisor'?: ValidateSendDocumentsResponseV5Advisor;
}
/**
 * 
 * @export
 * @interface ValidateSendDocumentsResponseV5Advisor
 */
export interface ValidateSendDocumentsResponseV5Advisor {
    /**
     * Advisor\'s full name.
     * @type {string}
     * @memberof ValidateSendDocumentsResponseV5Advisor
     */
    'fullName'?: string;
}


/**
 * ClientDocumentApi - axios parameter creator
 * @export
 */
export const ClientDocumentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Modify client document metadata.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} clientPidUuid Header for unique identifier of a client (Partners identity). 
         * @param {string} documentUuid Parameter for unique identifier of a document.
         * @param {ModifyClientDocumentMetadataRequestV5} modifyClientDocumentMetadataRequestV5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyClientDocumentMetadataV5: async (xCorrelationId: string, clientPidUuid: string, documentUuid: string, modifyClientDocumentMetadataRequestV5: ModifyClientDocumentMetadataRequestV5, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('modifyClientDocumentMetadataV5', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'clientPidUuid' is not null or undefined
            assertParamExists('modifyClientDocumentMetadataV5', 'clientPidUuid', clientPidUuid)
            // verify required parameter 'documentUuid' is not null or undefined
            assertParamExists('modifyClientDocumentMetadataV5', 'documentUuid', documentUuid)
            // verify required parameter 'modifyClientDocumentMetadataRequestV5' is not null or undefined
            assertParamExists('modifyClientDocumentMetadataV5', 'modifyClientDocumentMetadataRequestV5', modifyClientDocumentMetadataRequestV5)
            const localVarPath = `/bank-backofficegateway-documents/v5/client-documents/{documentUuid}/modify`
                .replace(`{${"documentUuid"}}`, encodeURIComponent(String(documentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (clientPidUuid != null) {
                localVarHeaderParameter['clientPidUuid'] = String(clientPidUuid);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(modifyClientDocumentMetadataRequestV5, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set client document visibility
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} owningPidUuid pidUuid of the owner of the document
         * @param {string} documentUuid Parameter for unique identifier of a document.
         * @param {SetDocumentVisibilityRequestV5} setDocumentVisibilityRequestV5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDocumentVisibilityV5: async (xCorrelationId: string, owningPidUuid: string, documentUuid: string, setDocumentVisibilityRequestV5: SetDocumentVisibilityRequestV5, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('setDocumentVisibilityV5', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'owningPidUuid' is not null or undefined
            assertParamExists('setDocumentVisibilityV5', 'owningPidUuid', owningPidUuid)
            // verify required parameter 'documentUuid' is not null or undefined
            assertParamExists('setDocumentVisibilityV5', 'documentUuid', documentUuid)
            // verify required parameter 'setDocumentVisibilityRequestV5' is not null or undefined
            assertParamExists('setDocumentVisibilityV5', 'setDocumentVisibilityRequestV5', setDocumentVisibilityRequestV5)
            const localVarPath = `/bank-backofficegateway-documents/v5/documents/{documentUuid}/set-visibility`
                .replace(`{${"documentUuid"}}`, encodeURIComponent(String(documentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (owningPidUuid != null) {
                localVarHeaderParameter['owningPidUuid'] = String(owningPidUuid);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setDocumentVisibilityRequestV5, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload client document for storage.
         * @summary Upload client document for storage
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} clientPidUuid Header for unique identifier of a client (Partners identity). 
         * @param {UploadClientDocumentInfoV5} uploadClientDocumentInfo 
         * @param {File} content 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadClientDocumentV5: async (xCorrelationId: string, clientPidUuid: string, uploadClientDocumentInfo: UploadClientDocumentInfoV5, content: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('uploadClientDocumentV5', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'clientPidUuid' is not null or undefined
            assertParamExists('uploadClientDocumentV5', 'clientPidUuid', clientPidUuid)
            // verify required parameter 'uploadClientDocumentInfo' is not null or undefined
            assertParamExists('uploadClientDocumentV5', 'uploadClientDocumentInfo', uploadClientDocumentInfo)
            // verify required parameter 'content' is not null or undefined
            assertParamExists('uploadClientDocumentV5', 'content', content)
            const localVarPath = `/bank-backofficegateway-documents/v5/client-documents/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (clientPidUuid != null) {
                localVarHeaderParameter['clientPidUuid'] = String(clientPidUuid);
            }


            if (uploadClientDocumentInfo !== undefined) { 
                localVarFormParams.append('uploadClientDocumentInfo', typeof uploadClientDocumentInfo === 'object' ? JSON.stringify(uploadClientDocumentInfo) : uploadClientDocumentInfo); // THIS IS CUSTOM
            }
    
            if (content !== undefined) { 
                localVarFormParams.append('content', content as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientDocumentApi - functional programming interface
 * @export
 */
export const ClientDocumentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientDocumentApiAxiosParamCreator(configuration)
    return {
        /**
         * Modify client document metadata.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} clientPidUuid Header for unique identifier of a client (Partners identity). 
         * @param {string} documentUuid Parameter for unique identifier of a document.
         * @param {ModifyClientDocumentMetadataRequestV5} modifyClientDocumentMetadataRequestV5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modifyClientDocumentMetadataV5(xCorrelationId: string, clientPidUuid: string, documentUuid: string, modifyClientDocumentMetadataRequestV5: ModifyClientDocumentMetadataRequestV5, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModifyClientDocumentMetadataResponseV5>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modifyClientDocumentMetadataV5(xCorrelationId, clientPidUuid, documentUuid, modifyClientDocumentMetadataRequestV5, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set client document visibility
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} owningPidUuid pidUuid of the owner of the document
         * @param {string} documentUuid Parameter for unique identifier of a document.
         * @param {SetDocumentVisibilityRequestV5} setDocumentVisibilityRequestV5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setDocumentVisibilityV5(xCorrelationId: string, owningPidUuid: string, documentUuid: string, setDocumentVisibilityRequestV5: SetDocumentVisibilityRequestV5, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setDocumentVisibilityV5(xCorrelationId, owningPidUuid, documentUuid, setDocumentVisibilityRequestV5, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Upload client document for storage.
         * @summary Upload client document for storage
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} clientPidUuid Header for unique identifier of a client (Partners identity). 
         * @param {UploadClientDocumentInfoV5} uploadClientDocumentInfo 
         * @param {File} content 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadClientDocumentV5(xCorrelationId: string, clientPidUuid: string, uploadClientDocumentInfo: UploadClientDocumentInfoV5, content: File, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadClientDocumentResponseV5>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadClientDocumentV5(xCorrelationId, clientPidUuid, uploadClientDocumentInfo, content, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ClientDocumentApi - factory interface
 * @export
 */
export const ClientDocumentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientDocumentApiFp(configuration)
    return {
        /**
         * Modify client document metadata.
         * @param {ClientDocumentApiModifyClientDocumentMetadataV5Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyClientDocumentMetadataV5(requestParameters: ClientDocumentApiModifyClientDocumentMetadataV5Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<ModifyClientDocumentMetadataResponseV5> {
            return localVarFp.modifyClientDocumentMetadataV5(requestParameters.xCorrelationId, requestParameters.clientPidUuid, requestParameters.documentUuid, requestParameters.modifyClientDocumentMetadataRequestV5, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set client document visibility
         * @param {ClientDocumentApiSetDocumentVisibilityV5Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDocumentVisibilityV5(requestParameters: ClientDocumentApiSetDocumentVisibilityV5Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<void> {
            return localVarFp.setDocumentVisibilityV5(requestParameters.xCorrelationId, requestParameters.owningPidUuid, requestParameters.documentUuid, requestParameters.setDocumentVisibilityRequestV5, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Upload client document for storage.
         * @summary Upload client document for storage
         * @param {ClientDocumentApiUploadClientDocumentV5Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadClientDocumentV5(requestParameters: ClientDocumentApiUploadClientDocumentV5Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<UploadClientDocumentResponseV5> {
            return localVarFp.uploadClientDocumentV5(requestParameters.xCorrelationId, requestParameters.clientPidUuid, requestParameters.uploadClientDocumentInfo, requestParameters.content, options, endpointOptions).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for modifyClientDocumentMetadataV5 operation in ClientDocumentApi.
 * @export
 * @type ClientDocumentApiModifyClientDocumentMetadataV5Request
 */
export type ClientDocumentApiModifyClientDocumentMetadataV5Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof ClientDocumentApiModifyClientDocumentMetadataV5
     */
    readonly xCorrelationId: string

    /**
     * Header for unique identifier of a client (Partners identity). 
     * @type {string}
     * @memberof ClientDocumentApiModifyClientDocumentMetadataV5
     */
    readonly clientPidUuid: string

    /**
     * Parameter for unique identifier of a document.
     * @type {string}
     * @memberof ClientDocumentApiModifyClientDocumentMetadataV5
     */
    readonly documentUuid: string

    /**
     * 
     * @type {ModifyClientDocumentMetadataRequestV5}
     * @memberof ClientDocumentApiModifyClientDocumentMetadataV5
     */
    readonly modifyClientDocumentMetadataRequestV5: ModifyClientDocumentMetadataRequestV5
}

/**
 * Request parameters for setDocumentVisibilityV5 operation in ClientDocumentApi.
 * @export
 * @type ClientDocumentApiSetDocumentVisibilityV5Request
 */
export type ClientDocumentApiSetDocumentVisibilityV5Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof ClientDocumentApiSetDocumentVisibilityV5
     */
    readonly xCorrelationId: string

    /**
     * pidUuid of the owner of the document
     * @type {string}
     * @memberof ClientDocumentApiSetDocumentVisibilityV5
     */
    readonly owningPidUuid: string

    /**
     * Parameter for unique identifier of a document.
     * @type {string}
     * @memberof ClientDocumentApiSetDocumentVisibilityV5
     */
    readonly documentUuid: string

    /**
     * 
     * @type {SetDocumentVisibilityRequestV5}
     * @memberof ClientDocumentApiSetDocumentVisibilityV5
     */
    readonly setDocumentVisibilityRequestV5: SetDocumentVisibilityRequestV5
}

/**
 * Request parameters for uploadClientDocumentV5 operation in ClientDocumentApi.
 * @export
 * @type ClientDocumentApiUploadClientDocumentV5Request
 */
export type ClientDocumentApiUploadClientDocumentV5Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof ClientDocumentApiUploadClientDocumentV5
     */
    readonly xCorrelationId: string

    /**
     * Header for unique identifier of a client (Partners identity). 
     * @type {string}
     * @memberof ClientDocumentApiUploadClientDocumentV5
     */
    readonly clientPidUuid: string

    /**
     * 
     * @type {UploadClientDocumentInfoV5}
     * @memberof ClientDocumentApiUploadClientDocumentV5
     */
    readonly uploadClientDocumentInfo: UploadClientDocumentInfoV5

    /**
     * 
     * @type {File}
     * @memberof ClientDocumentApiUploadClientDocumentV5
     */
    readonly content: File
}

/**
 * ClientDocumentApi - object-oriented interface
 * @export
 * @class ClientDocumentApi
 * @extends {BaseAPI}
 */
export class ClientDocumentApi extends BaseAPI {
    /**
     * Modify client document metadata.
     * @param {ClientDocumentApiModifyClientDocumentMetadataV5Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientDocumentApi
     */
    public modifyClientDocumentMetadataV5(requestParameters: ClientDocumentApiModifyClientDocumentMetadataV5Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return ClientDocumentApiFp(this.configuration).modifyClientDocumentMetadataV5(requestParameters.xCorrelationId, requestParameters.clientPidUuid, requestParameters.documentUuid, requestParameters.modifyClientDocumentMetadataRequestV5, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set client document visibility
     * @param {ClientDocumentApiSetDocumentVisibilityV5Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientDocumentApi
     */
    public setDocumentVisibilityV5(requestParameters: ClientDocumentApiSetDocumentVisibilityV5Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return ClientDocumentApiFp(this.configuration).setDocumentVisibilityV5(requestParameters.xCorrelationId, requestParameters.owningPidUuid, requestParameters.documentUuid, requestParameters.setDocumentVisibilityRequestV5, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload client document for storage.
     * @summary Upload client document for storage
     * @param {ClientDocumentApiUploadClientDocumentV5Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientDocumentApi
     */
    public uploadClientDocumentV5(requestParameters: ClientDocumentApiUploadClientDocumentV5Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return ClientDocumentApiFp(this.configuration).uploadClientDocumentV5(requestParameters.xCorrelationId, requestParameters.clientPidUuid, requestParameters.uploadClientDocumentInfo, requestParameters.content, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DocumentsApi - axios parameter creator
 * @export
 */
export const DocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get document audit log.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} documentUuid Parameter for unique identifier of a document.
         * @param {string} clientPidUuid Header for unique identifier of a client (Partners identity). 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentAuditLogV5: async (xCorrelationId: string, documentUuid: string, clientPidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('documentAuditLogV5', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'documentUuid' is not null or undefined
            assertParamExists('documentAuditLogV5', 'documentUuid', documentUuid)
            // verify required parameter 'clientPidUuid' is not null or undefined
            assertParamExists('documentAuditLogV5', 'clientPidUuid', clientPidUuid)
            const localVarPath = `/bank-backofficegateway-documents/v5/documents/{documentUuid}/audit-log`
                .replace(`{${"documentUuid"}}`, encodeURIComponent(String(documentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (clientPidUuid != null) {
                localVarHeaderParameter['clientPidUuid'] = String(clientPidUuid);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download bank or client document.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} owningPidUuid pidUuid of the owner of the document
         * @param {string} documentUuid Parameter for unique identifier of a document.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDocumentV5: async (xCorrelationId: string, owningPidUuid: string, documentUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('downloadDocumentV5', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'owningPidUuid' is not null or undefined
            assertParamExists('downloadDocumentV5', 'owningPidUuid', owningPidUuid)
            // verify required parameter 'documentUuid' is not null or undefined
            assertParamExists('downloadDocumentV5', 'documentUuid', documentUuid)
            const localVarPath = `/bank-backofficegateway-documents/v5/documents/{documentUuid}/download`
                .replace(`{${"documentUuid"}}`, encodeURIComponent(String(documentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (owningPidUuid != null) {
                localVarHeaderParameter['owningPidUuid'] = String(owningPidUuid);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate bank document.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} owningPidUuid pidUuid of the owner of the document
         * @param {GenerateBankDocumentRequestV5} generateBankDocumentRequestV5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBankDocumentV5: async (xCorrelationId: string, owningPidUuid: string, generateBankDocumentRequestV5: GenerateBankDocumentRequestV5, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('generateBankDocumentV5', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'owningPidUuid' is not null or undefined
            assertParamExists('generateBankDocumentV5', 'owningPidUuid', owningPidUuid)
            // verify required parameter 'generateBankDocumentRequestV5' is not null or undefined
            assertParamExists('generateBankDocumentV5', 'generateBankDocumentRequestV5', generateBankDocumentRequestV5)
            const localVarPath = `/bank-backofficegateway-documents/v5/documents/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (owningPidUuid != null) {
                localVarHeaderParameter['owningPidUuid'] = String(owningPidUuid);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateBankDocumentRequestV5, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get documents available to invoking user.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} clientPidUuid Header for unique identifier of a client (Partners identity). 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableDocumentsV5: async (xCorrelationId: string, clientPidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getAvailableDocumentsV5', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'clientPidUuid' is not null or undefined
            assertParamExists('getAvailableDocumentsV5', 'clientPidUuid', clientPidUuid)
            const localVarPath = `/bank-backofficegateway-documents/v5/documents/available-documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (clientPidUuid != null) {
                localVarHeaderParameter['clientPidUuid'] = String(clientPidUuid);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get bank document metadata. Returns only documents that are not expired.
         * @summary Get bank document metadata
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} documentUuid Parameter for unique identifier of a document.
         * @param {string} clientPidUuid Header for unique identifier of a client (Partners identity). 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankDocumentByUuidV5: async (xCorrelationId: string, documentUuid: string, clientPidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getBankDocumentByUuidV5', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'documentUuid' is not null or undefined
            assertParamExists('getBankDocumentByUuidV5', 'documentUuid', documentUuid)
            // verify required parameter 'clientPidUuid' is not null or undefined
            assertParamExists('getBankDocumentByUuidV5', 'clientPidUuid', clientPidUuid)
            const localVarPath = `/bank-backofficegateway-documents/v5/documents/{documentUuid}`
                .replace(`{${"documentUuid"}}`, encodeURIComponent(String(documentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (clientPidUuid != null) {
                localVarHeaderParameter['clientPidUuid'] = String(clientPidUuid);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search documents.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {SearchDocumentsRequestV5} searchDocumentsRequestV5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDocumentsV5: async (xCorrelationId: string, searchDocumentsRequestV5: SearchDocumentsRequestV5, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('searchDocumentsV5', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'searchDocumentsRequestV5' is not null or undefined
            assertParamExists('searchDocumentsV5', 'searchDocumentsRequestV5', searchDocumentsRequestV5)
            const localVarPath = `/bank-backofficegateway-documents/v5/documents/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchDocumentsRequestV5, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentsApi - functional programming interface
 * @export
 */
export const DocumentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get document audit log.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} documentUuid Parameter for unique identifier of a document.
         * @param {string} clientPidUuid Header for unique identifier of a client (Partners identity). 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async documentAuditLogV5(xCorrelationId: string, documentUuid: string, clientPidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDocumentAuditLogResponseV5>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.documentAuditLogV5(xCorrelationId, documentUuid, clientPidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Download bank or client document.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} owningPidUuid pidUuid of the owner of the document
         * @param {string} documentUuid Parameter for unique identifier of a document.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadDocumentV5(xCorrelationId: string, owningPidUuid: string, documentUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadDocumentV5(xCorrelationId, owningPidUuid, documentUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Generate bank document.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} owningPidUuid pidUuid of the owner of the document
         * @param {GenerateBankDocumentRequestV5} generateBankDocumentRequestV5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateBankDocumentV5(xCorrelationId: string, owningPidUuid: string, generateBankDocumentRequestV5: GenerateBankDocumentRequestV5, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateBankDocumentResponseV5>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateBankDocumentV5(xCorrelationId, owningPidUuid, generateBankDocumentRequestV5, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get documents available to invoking user.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} clientPidUuid Header for unique identifier of a client (Partners identity). 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableDocumentsV5(xCorrelationId: string, clientPidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAvailableDocumentsResponseV5>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableDocumentsV5(xCorrelationId, clientPidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get bank document metadata. Returns only documents that are not expired.
         * @summary Get bank document metadata
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} documentUuid Parameter for unique identifier of a document.
         * @param {string} clientPidUuid Header for unique identifier of a client (Partners identity). 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBankDocumentByUuidV5(xCorrelationId: string, documentUuid: string, clientPidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankDocumentInfoV5>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBankDocumentByUuidV5(xCorrelationId, documentUuid, clientPidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Search documents.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {SearchDocumentsRequestV5} searchDocumentsRequestV5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchDocumentsV5(xCorrelationId: string, searchDocumentsRequestV5: SearchDocumentsRequestV5, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDocumentsResponseV5>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchDocumentsV5(xCorrelationId, searchDocumentsRequestV5, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DocumentsApi - factory interface
 * @export
 */
export const DocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentsApiFp(configuration)
    return {
        /**
         * Get document audit log.
         * @param {DocumentsApiDocumentAuditLogV5Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentAuditLogV5(requestParameters: DocumentsApiDocumentAuditLogV5Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<GetDocumentAuditLogResponseV5> {
            return localVarFp.documentAuditLogV5(requestParameters.xCorrelationId, requestParameters.documentUuid, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Download bank or client document.
         * @param {DocumentsApiDownloadDocumentV5Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDocumentV5(requestParameters: DocumentsApiDownloadDocumentV5Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<File> {
            return localVarFp.downloadDocumentV5(requestParameters.xCorrelationId, requestParameters.owningPidUuid, requestParameters.documentUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Generate bank document.
         * @param {DocumentsApiGenerateBankDocumentV5Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBankDocumentV5(requestParameters: DocumentsApiGenerateBankDocumentV5Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<GenerateBankDocumentResponseV5> {
            return localVarFp.generateBankDocumentV5(requestParameters.xCorrelationId, requestParameters.owningPidUuid, requestParameters.generateBankDocumentRequestV5, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Get documents available to invoking user.
         * @param {DocumentsApiGetAvailableDocumentsV5Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableDocumentsV5(requestParameters: DocumentsApiGetAvailableDocumentsV5Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<GetAvailableDocumentsResponseV5> {
            return localVarFp.getAvailableDocumentsV5(requestParameters.xCorrelationId, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Get bank document metadata. Returns only documents that are not expired.
         * @summary Get bank document metadata
         * @param {DocumentsApiGetBankDocumentByUuidV5Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankDocumentByUuidV5(requestParameters: DocumentsApiGetBankDocumentByUuidV5Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<BankDocumentInfoV5> {
            return localVarFp.getBankDocumentByUuidV5(requestParameters.xCorrelationId, requestParameters.documentUuid, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Search documents.
         * @param {DocumentsApiSearchDocumentsV5Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDocumentsV5(requestParameters: DocumentsApiSearchDocumentsV5Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<SearchDocumentsResponseV5> {
            return localVarFp.searchDocumentsV5(requestParameters.xCorrelationId, requestParameters.searchDocumentsRequestV5, options, endpointOptions).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for documentAuditLogV5 operation in DocumentsApi.
 * @export
 * @type DocumentsApiDocumentAuditLogV5Request
 */
export type DocumentsApiDocumentAuditLogV5Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof DocumentsApiDocumentAuditLogV5
     */
    readonly xCorrelationId: string

    /**
     * Parameter for unique identifier of a document.
     * @type {string}
     * @memberof DocumentsApiDocumentAuditLogV5
     */
    readonly documentUuid: string

    /**
     * Header for unique identifier of a client (Partners identity). 
     * @type {string}
     * @memberof DocumentsApiDocumentAuditLogV5
     */
    readonly clientPidUuid: string
}

/**
 * Request parameters for downloadDocumentV5 operation in DocumentsApi.
 * @export
 * @type DocumentsApiDownloadDocumentV5Request
 */
export type DocumentsApiDownloadDocumentV5Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof DocumentsApiDownloadDocumentV5
     */
    readonly xCorrelationId: string

    /**
     * pidUuid of the owner of the document
     * @type {string}
     * @memberof DocumentsApiDownloadDocumentV5
     */
    readonly owningPidUuid: string

    /**
     * Parameter for unique identifier of a document.
     * @type {string}
     * @memberof DocumentsApiDownloadDocumentV5
     */
    readonly documentUuid: string
}

/**
 * Request parameters for generateBankDocumentV5 operation in DocumentsApi.
 * @export
 * @type DocumentsApiGenerateBankDocumentV5Request
 */
export type DocumentsApiGenerateBankDocumentV5Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof DocumentsApiGenerateBankDocumentV5
     */
    readonly xCorrelationId: string

    /**
     * pidUuid of the owner of the document
     * @type {string}
     * @memberof DocumentsApiGenerateBankDocumentV5
     */
    readonly owningPidUuid: string

    /**
     * 
     * @type {GenerateBankDocumentRequestV5}
     * @memberof DocumentsApiGenerateBankDocumentV5
     */
    readonly generateBankDocumentRequestV5: GenerateBankDocumentRequestV5
}

/**
 * Request parameters for getAvailableDocumentsV5 operation in DocumentsApi.
 * @export
 * @type DocumentsApiGetAvailableDocumentsV5Request
 */
export type DocumentsApiGetAvailableDocumentsV5Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof DocumentsApiGetAvailableDocumentsV5
     */
    readonly xCorrelationId: string

    /**
     * Header for unique identifier of a client (Partners identity). 
     * @type {string}
     * @memberof DocumentsApiGetAvailableDocumentsV5
     */
    readonly clientPidUuid: string
}

/**
 * Request parameters for getBankDocumentByUuidV5 operation in DocumentsApi.
 * @export
 * @type DocumentsApiGetBankDocumentByUuidV5Request
 */
export type DocumentsApiGetBankDocumentByUuidV5Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof DocumentsApiGetBankDocumentByUuidV5
     */
    readonly xCorrelationId: string

    /**
     * Parameter for unique identifier of a document.
     * @type {string}
     * @memberof DocumentsApiGetBankDocumentByUuidV5
     */
    readonly documentUuid: string

    /**
     * Header for unique identifier of a client (Partners identity). 
     * @type {string}
     * @memberof DocumentsApiGetBankDocumentByUuidV5
     */
    readonly clientPidUuid: string
}

/**
 * Request parameters for searchDocumentsV5 operation in DocumentsApi.
 * @export
 * @type DocumentsApiSearchDocumentsV5Request
 */
export type DocumentsApiSearchDocumentsV5Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof DocumentsApiSearchDocumentsV5
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {SearchDocumentsRequestV5}
     * @memberof DocumentsApiSearchDocumentsV5
     */
    readonly searchDocumentsRequestV5: SearchDocumentsRequestV5
}

/**
 * DocumentsApi - object-oriented interface
 * @export
 * @class DocumentsApi
 * @extends {BaseAPI}
 */
export class DocumentsApi extends BaseAPI {
    /**
     * Get document audit log.
     * @param {DocumentsApiDocumentAuditLogV5Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public documentAuditLogV5(requestParameters: DocumentsApiDocumentAuditLogV5Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return DocumentsApiFp(this.configuration).documentAuditLogV5(requestParameters.xCorrelationId, requestParameters.documentUuid, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download bank or client document.
     * @param {DocumentsApiDownloadDocumentV5Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public downloadDocumentV5(requestParameters: DocumentsApiDownloadDocumentV5Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return DocumentsApiFp(this.configuration).downloadDocumentV5(requestParameters.xCorrelationId, requestParameters.owningPidUuid, requestParameters.documentUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate bank document.
     * @param {DocumentsApiGenerateBankDocumentV5Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public generateBankDocumentV5(requestParameters: DocumentsApiGenerateBankDocumentV5Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return DocumentsApiFp(this.configuration).generateBankDocumentV5(requestParameters.xCorrelationId, requestParameters.owningPidUuid, requestParameters.generateBankDocumentRequestV5, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get documents available to invoking user.
     * @param {DocumentsApiGetAvailableDocumentsV5Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getAvailableDocumentsV5(requestParameters: DocumentsApiGetAvailableDocumentsV5Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return DocumentsApiFp(this.configuration).getAvailableDocumentsV5(requestParameters.xCorrelationId, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get bank document metadata. Returns only documents that are not expired.
     * @summary Get bank document metadata
     * @param {DocumentsApiGetBankDocumentByUuidV5Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getBankDocumentByUuidV5(requestParameters: DocumentsApiGetBankDocumentByUuidV5Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return DocumentsApiFp(this.configuration).getBankDocumentByUuidV5(requestParameters.xCorrelationId, requestParameters.documentUuid, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search documents.
     * @param {DocumentsApiSearchDocumentsV5Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public searchDocumentsV5(requestParameters: DocumentsApiSearchDocumentsV5Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return DocumentsApiFp(this.configuration).searchDocumentsV5(requestParameters.xCorrelationId, requestParameters.searchDocumentsRequestV5, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PfsDocumentsApi - axios parameter creator
 * @export
 */
export const PfsDocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Sends documents to PFS.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {SendDocumentsRequestV5} sendDocumentsRequestV5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendDocumentsV5: async (xCorrelationId: string, sendDocumentsRequestV5: SendDocumentsRequestV5, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('sendDocumentsV5', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'sendDocumentsRequestV5' is not null or undefined
            assertParamExists('sendDocumentsV5', 'sendDocumentsRequestV5', sendDocumentsRequestV5)
            const localVarPath = `/bank-backofficegateway-documents/v5/pfs/documents/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendDocumentsRequestV5, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validates whether the operation of sending documents can be done.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {SendDocumentsRequestV5} sendDocumentsRequestV5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateSendDocumentsV5: async (xCorrelationId: string, sendDocumentsRequestV5: SendDocumentsRequestV5, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('validateSendDocumentsV5', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'sendDocumentsRequestV5' is not null or undefined
            assertParamExists('validateSendDocumentsV5', 'sendDocumentsRequestV5', sendDocumentsRequestV5)
            const localVarPath = `/bank-backofficegateway-documents/v5/pfs/documents/send/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendDocumentsRequestV5, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PfsDocumentsApi - functional programming interface
 * @export
 */
export const PfsDocumentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PfsDocumentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Sends documents to PFS.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {SendDocumentsRequestV5} sendDocumentsRequestV5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendDocumentsV5(xCorrelationId: string, sendDocumentsRequestV5: SendDocumentsRequestV5, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendDocumentsResponseV5>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendDocumentsV5(xCorrelationId, sendDocumentsRequestV5, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Validates whether the operation of sending documents can be done.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {SendDocumentsRequestV5} sendDocumentsRequestV5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateSendDocumentsV5(xCorrelationId: string, sendDocumentsRequestV5: SendDocumentsRequestV5, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateSendDocumentsResponseV5>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateSendDocumentsV5(xCorrelationId, sendDocumentsRequestV5, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PfsDocumentsApi - factory interface
 * @export
 */
export const PfsDocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PfsDocumentsApiFp(configuration)
    return {
        /**
         * Sends documents to PFS.
         * @param {PfsDocumentsApiSendDocumentsV5Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendDocumentsV5(requestParameters: PfsDocumentsApiSendDocumentsV5Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<SendDocumentsResponseV5> {
            return localVarFp.sendDocumentsV5(requestParameters.xCorrelationId, requestParameters.sendDocumentsRequestV5, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Validates whether the operation of sending documents can be done.
         * @param {PfsDocumentsApiValidateSendDocumentsV5Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateSendDocumentsV5(requestParameters: PfsDocumentsApiValidateSendDocumentsV5Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<ValidateSendDocumentsResponseV5> {
            return localVarFp.validateSendDocumentsV5(requestParameters.xCorrelationId, requestParameters.sendDocumentsRequestV5, options, endpointOptions).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for sendDocumentsV5 operation in PfsDocumentsApi.
 * @export
 * @type PfsDocumentsApiSendDocumentsV5Request
 */
export type PfsDocumentsApiSendDocumentsV5Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PfsDocumentsApiSendDocumentsV5
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {SendDocumentsRequestV5}
     * @memberof PfsDocumentsApiSendDocumentsV5
     */
    readonly sendDocumentsRequestV5: SendDocumentsRequestV5
}

/**
 * Request parameters for validateSendDocumentsV5 operation in PfsDocumentsApi.
 * @export
 * @type PfsDocumentsApiValidateSendDocumentsV5Request
 */
export type PfsDocumentsApiValidateSendDocumentsV5Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PfsDocumentsApiValidateSendDocumentsV5
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {SendDocumentsRequestV5}
     * @memberof PfsDocumentsApiValidateSendDocumentsV5
     */
    readonly sendDocumentsRequestV5: SendDocumentsRequestV5
}

/**
 * PfsDocumentsApi - object-oriented interface
 * @export
 * @class PfsDocumentsApi
 * @extends {BaseAPI}
 */
export class PfsDocumentsApi extends BaseAPI {
    /**
     * Sends documents to PFS.
     * @param {PfsDocumentsApiSendDocumentsV5Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PfsDocumentsApi
     */
    public sendDocumentsV5(requestParameters: PfsDocumentsApiSendDocumentsV5Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PfsDocumentsApiFp(this.configuration).sendDocumentsV5(requestParameters.xCorrelationId, requestParameters.sendDocumentsRequestV5, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validates whether the operation of sending documents can be done.
     * @param {PfsDocumentsApiValidateSendDocumentsV5Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PfsDocumentsApi
     */
    public validateSendDocumentsV5(requestParameters: PfsDocumentsApiValidateSendDocumentsV5Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PfsDocumentsApiFp(this.configuration).validateSendDocumentsV5(requestParameters.xCorrelationId, requestParameters.sendDocumentsRequestV5, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }
}


